import React, { Component, Fragment } from 'react';
import Classname from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as CloseIcon } from 'Icons/close.svg';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import ResponsiveTable from 'Components/ResponsiveTable';
import Checkbox from 'Components/Checkbox';
import Timer from 'Components/Timer';
import Tk11Popup from 'Components/Tk11Popup';
import LineItemDetail from 'Components/LineItemDetail/index';
import { ReactComponent as AcceptIcon } from 'Icons/checked.svg'
import { ReactComponent as RejectIcon } from 'Icons/reject.svg'
import { ReactComponent as DropdownIcon } from 'Icons/downArrow.svg';
import { getUser, getDashboardActiveView, getCookie  } from 'Utils/storage';
import { StickyContainer, Sticky } from 'react-sticky';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { ReactComponent as SEOIcon } from 'Icons/seo.svg';
import { ReactComponent as CostIcon } from 'Icons/cost.svg';
import { ReactComponent as UpArrow } from 'Icons/uparrow.svg';
import { ReactComponent as DownArrow } from 'Icons/d-arrow.svg';
import BidHistoryPopUp from 'Components/SeekerBidsTable/BidHistoryPopUp';
import NumberOfVehiclePlaced from 'Components/SeekerBidsTable/NumberOfVehiclePlaced';
import CancelLOiPopUp from 'Components/SeekerBidsTable/CancelLOiPopUp';
import UploadFilePopup from './uploadFilePopup';
import ViewLOIRemarks from './ViewLOIRemarksPopup';
import {
   GET_LPP_DETAILS, CHANGE_TRIP_BASE_VOLUME, FETCH_BIDS, LOI_CANCELLED, DOWNLOAD_UPLOADED_FILE, POST_TRIP_FILE_REMARKS, UPLOAD_DOCUMENT,
   POST_SHARE_OF_BUSINESS
} from 'Constants/actionConstants';

import TimePicker from 'rc-time-picker';
import Moment from 'moment';
import { SingleDatePicker } from 'react-dates';

import { scroll } from 'Utils/';
import TripTableHeader from 'Components/TripTableHeader';
import { Status } from 'Components/Status';
import ReactTooltip from 'react-tooltip';
import OutsideClickHandler from 'react-outside-click-handler';
import Input from '../Input/index';
import { SINGLE_MODE, MULTI_MODE, MULTI_MODE_LEG, MULTI_MODE_COST, CHALLENGE_PRICE_ACCEPTED, CHALLENGE_PRICE_REJECTED, NO_OF_LPP_DISPLAY, COUNTER_ACCEPT, COUNTER_REJECT, COUNTER_RESENT, SECONDARY_MODE, Courier_data, ZONE_LIST, EXIM_RFQ_TYPE, ACC, AWL_MULTI_MODE, HIKAL, GENERAL_PROCUREMENT, GREEN_PLY, DEEPAK_PHENOLICS, CENTURY_PLY, ROQUETTE, EMAMI, CARGIL, TK11STATUS, AWL_AND_CPL, STAR_CEMENT, ABFRL, GALAXY_SURFACE, BEAM, DEEPAK_PHENOLICS_SAP, CONTAINER_RFQ,DALMIA_CEMENT, POLYCAB, CHALLENGE_PRICE_CANCELLED, COROMANDEL } from 'Constants/commonConstants';
import {toPascalCase} from '../../utils/validate';
import CommonChargesPopUp from 'Components/SeekerBidsTable/CommonChargesPopUp';
import CostHeadCalculation from './CostHeadCalculation';
import { isAdaniWilmar } from 'Utils/';
import { RFQFTLTripsTable } from 'Components/RFQFTLTripsTable';
import { ApprovalMatrixDetails } from './ApprovalMatrixDetails';
import DisposalProductSeekerBids from './disposalProductSeekerBids';
import { ApprovalRejectedStatus } from './ApprovalRejectedStatus';

import rfq from 'Reducers/rfq';
import { isCoromandel, isDesmet, isGreenPly, isHikal, isVishaka } from 'Utils/index';

class SeekerBidsTable extends Component {
   constructor(props) {
      super(props);
      this.state = {
         bid: null,
         trip: null,
         tripLPP: {},
         selectedBids: [],
         isBidsShown: true,
         biddingEnd: '',
         isChangeBidShown: '',
         baseVolume: 0,
         hasCharges: false,
         cpvalue: {},
         cpvalueUSD: {},
         cpvalueSecondary: {},
         cpExtraCostvalue: {},
         headingCostCPValue: [],
         slabCPValue: [],
         openPopup: false,
         currentIndex:-1,
         isLoiCancelPopupShown: false,
         loiCancelRemark : "",
         sobValues: [],
         showUploadPopup:false,
         viewLOIremarksdetailsPopup:false,
         loi_docs: [],
         loi_remarks:"",
	   }
   }

   onChangeBaseVolume = (trip, e) => {
      this.setState({ baseVolume: e.target.value });
   }

   onChange = (trip, e) => {
      const { dispatch } = this.props;
      const { baseVolume } = this.state;

      let tripDetails = {
         trip_id: trip.id,
         base_volume: baseVolume
      }

      let tripDetails1 = [];
      tripDetails1.push(tripDetails);

      dispatch({
         type: CHANGE_TRIP_BASE_VOLUME,
         data: {
            trips: tripDetails1,
            rfq_id: trip.rfqId
         }
      });
   }

   onChangeBusinessAll = (trip, value, transporterId) => {
      if (trip && trip.bids.length > 0 && this.state.hasBusinessChanged) {
         this.setState({ hasBusinessChanged: false, trip: null });

         let tripDetails = {
            trip_id: trip.id,
            business_allocation: parseInt(value),
            transporter_id: transporterId
         };

         this.props.dispatch({
            type: CHANGE_TRIP_BASE_VOLUME,
            data: {
               allocation_for_transporter: true,
               trips: [tripDetails],
               rfq_id: trip.rfqId
            }
         });
      }
   }

   onBusinessChange = (trip, e, transporterId) => {
      e.stopPropagation();
      if (trip && trip.bids.length > 0) {
         let totalAll = 0;

         for (let i = 0; (i < trip.bids.length); i++) {
            if (trip.bids[i].transporterId !== transporterId) {
               totalAll += parseInt(trip.bids[i].business_allocation);
            } else {
               totalAll += parseInt(e.target.value);
            }
         }

         if (totalAll > 100) {
            alert("Allocation cannot be greater than 100%");
            const { trip } = this.state;
            if (trip && trip.bids.length > 0) {
               const bidIndex = (trip.bids || []).findIndex(bid => bid.transporterId === transporterId);
               if (trip.bids[bidIndex].business_allocation != e.target.value) {
                  trip.bids[bidIndex].business_allocation = '';
                  this.setState({ hasBusinessChanged: false });
               }
            }
            return;
         } else {
            const { trip } = this.state;
            if (trip && trip.bids.length > 0) {
               const bidIndex = (trip.bids || []).findIndex(bid => bid.transporterId === transporterId);
               if (trip.bids[bidIndex].business_allocation != e.target.value) {
                  trip.bids[bidIndex].business_allocation = e.target.value;
                  this.setState({ trip, hasBusinessChanged: true });
               }
            }
         }
      }
   }

   componentWillMount() {
      const { dispatch, trips } = this.props;
      let lpp_trips = {};
      const user = getUser();
      trips.map((trip) => {
         lpp_trips[trip.id] = {
            companyId: (user && user.companyId) ? user.companyId : null,
            source: trip.from,
            destination: trip.to,
            vehicle_type: trip.vehicleTypeName,
         };
      });

      dispatch({
         type: GET_LPP_DETAILS,
         data: lpp_trips,
         onSuccess: ((data) => {
            const { tripLPP } = this.state;
            this.setState({ tripLPP: data });
         }),
      });

   }
   toggleBidsShown = () => {
      this.setState({
         isBidsShown: !this.state.isBidsShown
      })
   }
   setBidAndTrip = (e, bid, trip) => {
      e.stopPropagation();
      e.preventDefault();
      this.setState({
         bid,
         trip,
         tripDetail: null
      }, scroll);
   }
   closeBidAndTRip = () => {
      this.setState({
         bid: null,
         trip: null
      })
   }
   showTripDetail = (tripDetail, hasCharges) => {
      if (hasCharges) {
         this.setState({ hasCharges });
      }
      this.setState({
         tripDetail,
         bid: null
      }, scroll)
   }
   hideTripDetail = () => {
      if (this.state.hasCharges) {
         this.setState({ hasCharges: false });
      }
      this.setState({
         tripDetail: null
      })
   }

   deleteTripDetailsShowPop = () => {
      const { rfq } = this.props;
      const { trip_id, rfq_id, parent_trip_id } = this.state;
      if (rfq.trips.length !== 1) {
         this.props.deleteTripDetails(trip_id, rfq_id, parent_trip_id);
         this.setState({
            showCancelPopup: false
         })
      } else if (rfq && rfq.trips && rfq.trips.length === 1) {
         this.props.deleteTripDetails(trip_id, rfq_id, parent_trip_id);
         this.setState({
            showCancelPopup: false
         })

      }
   }


   deleteTripDetails = (tripValue) => {
      this.setState({
         showCancelPopup: true,
         trip_id: tripValue.id,
         rfq_id: tripValue.rfqId,
         parent_trip_id: tripValue.subTripId
      })
   }


   selectBid = (bid) => {
      let selectedBids = [...this.props.selectedBids];
      const id = bid.id;
      if (selectedBids.findIndex((bid) => {
         return bid && (bid.id === id);
      }) < 0) {
         selectedBids.push(bid);
      } else {
         selectedBids = selectedBids.filter((bid) => {
            return bid && (bid.id !== id)
         });
      }
      this.props.setBids(selectedBids);
   }
   toggleAllOrders = (orderIndex, orderText, ltc_order_text) => {
      const selectedBids = [...this.props.selectedBids];
      const { rfq } = this.props;
      const isAdaniCompleteSolution = (isAdaniWilmar() && rfq.type === 3 && rfq.rfqDetails.secondaryContractType === 2 && !rfq.rfqDetails.acceptPartialSolution);
      const isEmamiCompleteSolution = ([...EMAMI, ...STAR_CEMENT, ...GREEN_PLY].includes(getUser().companyId) && rfq && !rfq.rfqDetails.acceptPartialSolution);
      let isLTC = this.props.rfq.rfqTypeLtc == "LTC";
      let isRoquette = ROQUETTE.includes(getUser().companyId);
      // console.log(isLTC)
      const trimmedBids = selectedBids.filter((bid) => {
         return isEmamiCompleteSolution ? bid.sum_order_text !== ltc_order_text : (isAdaniCompleteSolution ? bid.freight_rate_order_text !== ltc_order_text : (isLTC ? bid.ltc_order_text !== ltc_order_text : ((bid || {})[isRoquette ? 'sum_order_text' : 'orderText']) !== orderText));
      });
      let hasSubs = false;
      let bidsOfOrder = (this.props.trips || []).map((trip) => {
         if ((trip.subTrips || []).length > 0) {
            hasSubs = true;
            return (trip.subTrips).map((trp) => {
               const bid = trp.bids[orderIndex];
               if (trp.bids.length > orderIndex && (bid.cancelLoiEnableorDisable ? (bid.cancelLoiSendCount < bid.minimumCountSendToCancelLoi) : !bid.cancelLoiEnableorDisable)) {
                  return trp.bids[orderIndex];
               }
            })
         } else {
            const bid = isRoquette ? (trip.bids || []).find(el => el['sum_order_text'] === orderText) : trip.bids[orderIndex];
            if ((isRoquette ? bid : trip.bids.length > orderIndex) &&  (bid.cancelLoiEnableorDisable ? (bid.cancelLoiSendCount < bid.minimumCountSendToCancelLoi) : !bid.cancelLoiEnableorDisable)) {
               return isRoquette ? bid : trip.bids[orderIndex];
            } else {
               return null;
            }
         }
      }).filter((item) => {
         return item;
      });

      if (hasSubs && bidsOfOrder.length > 0) {
         let allBids = [];
         for (let i = 0; i < bidsOfOrder.length; i++) {
            for (let j = 0; j < bidsOfOrder[i].length; j++) {
               if(bidsOfOrder[i][j]) {
                  allBids.push(bidsOfOrder[i][j]);
               }
            }
         }
         bidsOfOrder = allBids;
      }
      if ((selectedBids.length - trimmedBids.length) === bidsOfOrder.length) {
         this.props.setBids(trimmedBids)
      } else {
         this.props.setBids([...trimmedBids, ...bidsOfOrder])
      }
   }

   toggleAllBids = (trip) => {
      const selectedBids = [...this.props.selectedBids];

      const trimmedBids = selectedBids.filter((bid) => {
         return bid.tripId !== trip.id;
      });
      if ((selectedBids.length - trimmedBids.length) === (trip.bids || []).filter(bid => (bid.cancelLoiEnableorDisable ? (bid.cancelLoiSendCount < bid.minimumCountSendToCancelLoi) : !bid.cancelLoiEnableorDisable )).length) {
         this.props.setBids(trimmedBids);
         // this.props.selectTrip(trip);
      } else {
         this.props.setBids([...trimmedBids, ...trip.bids]);
         // this.props.selectTrip(trip);
      }
   }

   toggleAllOrdersText = (e, orderIndex, orderText, tripList) => {
      const selectedBids = [...this.props.selectedBids];
      (tripList || []).forEach(trip => {
         if(trip.bids.length > orderIndex) {
            const selIndex = selectedBids.findIndex(selbid => {
               return ((selbid.id === trip.bids[orderIndex].id) && (selbid.orderText === orderText))
            });
            if(selIndex >= 0 && !e.target.checked) {
               selectedBids.splice(selIndex, 1);
            } else if(e.target.checked && selIndex === -1) {
               selectedBids.push(trip.bids[orderIndex]);
            }
         }
      })
      this.props.setBids(selectedBids);
   }

   toggleAllZoneBids = (e, tripList) => {
      let selectedBids = [...this.props.selectedBids];
      const { checked } = e.target;
      (tripList || []).forEach(trip => {
         if(checked) {
            (trip.bids || []).forEach(bid => {
               const selFindIndx = selectedBids.findIndex(selBid => selBid.id === bid.id);
               if(selFindIndx < 0) {
                  selectedBids.push(bid);
               }
            })
            // selectedBids = [...selectedBids , ...trip.bids];
         } else {
            const trimmedBids = selectedBids.filter((bid) => {
               return bid.tripId !== trip.id;
            });
            selectedBids = [...trimmedBids];
         }
      })
      this.props.setBids(selectedBids);
   }

   getToggleSelectedBids = (orderLevel) => {
      const { trips, selectedBids } = this.props;
      const tripBids = [];
      (trips || []).forEach(trip =>{
         const tBid = (trip.bids || []).find(bid => bid.sum_order_text === orderLevel);
         if(tBid) {
            tripBids.push(tBid);
         }
      });
      return tripBids.length > 0 && tripBids.length === selectedBids.filter(sBid => sBid.sum_order_text === orderLevel).length;
   }

   getLineItemsHeader = (isChargesDisplay) => {
      const { trips, isTK11 , rfq, systemTime, bided_transporter_name} = this.props;
      const isRoquette = ROQUETTE.includes(getUser().companyId);
      const headers = [];
      trips.forEach((mtrip, index) => {
         if ((mtrip.subTrips || []).length > 0) {
            (mtrip.subTrips || []).forEach((trip) => {
               const bidLength = (trip.bids || []).length;
               if (bidLength > headers.length) {
                  for (let i = headers.length; i < bidLength; ++i) {
                     const orderLevel = trip.bids[i].orderText ? trip.bids[i].orderText : (trip.bids[i].price === 0 ? 'L1' : trip.bids[i].orderText);
                     headers.push(
                        <div className={Classname('flex flex-middle pl-15',{
                           'wt-100': isChargesDisplay,
                           'wt-250': !isChargesDisplay && ![5,13,14,15].includes(trip.rfqType),
                           'wt-300': !isChargesDisplay && [5,13,14,15].includes(trip.rfqType)
                        })}key={trip.bids[i].orderText}>
                           {!isTK11 && !isChargesDisplay && !(rfq.type === 1 && ['737'].includes(rfq.companyId)) && <Checkbox
                              type="square"
                              checked={this.props.selectedBids.filter((bid) => {
                                 return bid && (bid.orderText === trip.bids[i].orderText)
                              }).length >= mtrip.subTrips.filter((trp) => {
                                 return (trp.bids || []).length > i
                              }).length}
                              onCheck={this.toggleAllOrders.bind(this, i, trip.bids[i].orderText)}
                              isBids="true"
                           />}
                           <div className="fBold fs-14 header-dark-color">
                              {orderLevel}
                              {rfq.type === 8 && (rfq.rfqDetails || {}).biddingEnd < systemTime && <Link to={"/poformat/" + rfq.id + "/" + rfq.type + '/' + trip.bids[i].orderText + '/' + this.props.loiApproverType} className="fBold fs-12 theme-color ml-5">PO</Link>}
                           </div>
                           {rfq && rfq.rfqDetails.biddingEnd > systemTime &&  !rfq.rfqDetails.acceptPartialSolution && trip.bids[i].isWithDrawBid && <div className="fBold fs-12 curP  success-color ml-5" onClick={(e) => this.revokeWithdrawBid(e, trip.bids[i])}>Revoke Bid</div>}
                        </div>
                     )
                  }
               }
            })
         } else {
            const trip = mtrip;
            const isRoquette = ROQUETTE.includes(getUser().companyId);
            const activeTripBids = rfq.isEnableWithdrawBid ? (trip.bids || []).filter(bid => !bid.isWithDrawBid || bid.isAccessBidWithdrawn) : (trip.bids || []);
            const bidLength = (isRoquette && (rfq.rfqDetails.biddingEnd < systemTime)) ? bided_transporter_name.length : activeTripBids.length;
            if (bidLength > headers.length) {
               for (let i = headers.length; i < bidLength; ++i) {
                  if(!activeTripBids[i]) {
                     activeTripBids[i] = {};
                  }
                  const isAdaniCompleteSolution = (isAdaniWilmar() && rfq.type === 3 && rfq.rfqDetails.secondaryContractType === 2 && !rfq.rfqDetails.acceptPartialSolution);
                  const isEmamiCompleteSolution = ([...EMAMI, ...STAR_CEMENT, ...GREEN_PLY].includes(getUser().companyId) && rfq && !rfq.rfqDetails.acceptPartialSolution);
                  let orderLevel = isEmamiCompleteSolution ? (activeTripBids[i].sum_order_text ? activeTripBids[i].sum_order_text : (activeTripBids[i].price === 0 ? 'L1' : activeTripBids[i].sum_order_text)) : (isAdaniCompleteSolution ? ( activeTripBids[i].freight_rate_order_text ? activeTripBids[i].freight_rate_order_text : (activeTripBids[i].price === 0 ? 'L1' : activeTripBids[i].freight_rate_order_text)) : (rfq.rfqTypeLtc==="LTC"  && !rfq.rfqDetails.acceptPartialSolution) ? ( activeTripBids[i].ltc_order_text ? activeTripBids[i].ltc_order_text : (activeTripBids[i].price === 0 ? 'L1' : activeTripBids[i].ltc_order_text)) : ((activeTripBids[i] || {}).orderText ? activeTripBids[i].orderText : (activeTripBids[i].price === 0 ? 'L1' : activeTripBids[i].orderText)));
                  let totalPrice = 0;
                  if((isRoquette && (rfq.rfqDetails.biddingEnd < systemTime))) {
                     (trips || []).forEach(trip => {
                        (trip.bids || []).forEach(bid => {
                           if(!totalPrice && bid.transporterName === bided_transporter_name[i].transporter_name) {
                              totalPrice = bid.sumOfProductPrice
                           }
                        })
                     })
                  }
                  headers.push(
                     <div className={Classname('flex flex-middle pl-15',{
                        'wt-100': isChargesDisplay,
                        'wt-250': !isChargesDisplay && ![5,13,14,15].includes(trip.rfqType),
                        'wt-300': !isChargesDisplay && [5,13,14,15].includes(trip.rfqType)
                     })} key={activeTripBids[i].orderText}>
                        {!isTK11 && !isChargesDisplay && !(rfq.type === 1 && ['737'].includes(rfq.companyId)) && <Checkbox
                           type="square"
                           checked={isRoquette ? this.getToggleSelectedBids((bided_transporter_name[i] || {}).sum_order_text) : this.props.selectedBids.filter((bid) => {
                              return  isEmamiCompleteSolution ? bid.sum_order_text === activeTripBids[i].sum_order_text : (isAdaniCompleteSolution ? bid.freight_rate_order_text === activeTripBids[i].freight_rate_order_text : (rfq.rfqTypeLtc==="LTC" ? bid.ltc_order_text === activeTripBids[i].ltc_order_text : bid.orderText === activeTripBids[i].orderText))
                           }).length >= trips.filter((trip) => {
                              return (trip.bids || []).filter(b => !b.isWithDrawBid || b.isAccessBidWithdrawn).length > i
                           }).length}
                           onCheck={this.toggleAllOrders.bind(this, i,((isRoquette && (rfq.rfqDetails.biddingEnd < systemTime)) ? ((bided_transporter_name[i] || {}).sum_order_text || `L${i}`) : activeTripBids[i].orderText), isEmamiCompleteSolution ? activeTripBids[i].sum_order_text: (isAdaniCompleteSolution ? activeTripBids[i].freight_rate_order_text : activeTripBids[i].ltc_order_text))}
                           isBids="true"
                        />}
                        <div>
                        <div className="fBold fs-14 header-dark-color">{isEmamiCompleteSolution ? `${activeTripBids[i].transporterName} (${orderLevel})` : ((isRoquette && (rfq.rfqDetails.biddingEnd < systemTime)) ? bided_transporter_name[i].transporter_name : orderLevel)}
                        </div>
                        { trip && activeTripBids && (isRoquette ? (rfq.rfqDetails.biddingEnd < systemTime) : true) && (isRoquette ? totalPrice : activeTripBids[i].sumOfProductPrice) &&<div className="fBold fs-12 theme-color ml-5">Total Price:₹{(isRoquette ? totalPrice : activeTripBids[i].sumOfProductPrice).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
                        </div>
                        {trip && activeTripBids && activeTripBids[i].sum_price_volume_mt &&<div className="fBold fs-12 theme-color">Total Value (MT): ₹{(activeTripBids[i].sum_price_volume_mt).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
                        {rfq && rfq.rfqDetails.biddingEnd > systemTime &&  !rfq.rfqDetails.acceptPartialSolution && activeTripBids[i].isWithDrawBid && <div className="fBold fs-12 curP  success-color ml-5" onClick={(e) => this.revokeWithdrawBid(e, activeTripBids[i])}>Revoke Bid</div>}
                     </div>
                  )
               }
            }
         }

      });
      return headers;
   }

   showChangeBidding = (e, trip) => {
      e.preventDefault();
      this.setState({ isChangeBidShown: trip.id });
   }
   hideChangeBidding = () => {
      this.setState({ isChangeBidShown: '' });
   }
   updateBiddingEnd = (trip) => {
      // const { dispatch, rfq } = this.props;
      // const { biddingEnd } = this.state;
      this.hideChangeBidding();
      this.props.postBid(trip.id, this.state.biddingEnd);
      // if(biddingEnd === rfq.rfqDetails.biddingEnd || !biddingEnd) {
      //     return;
      // }
      // dispatch({
      //     type: CHANGE_BID_END,
      //     data: {
      //         rfq_id: rfq.id,
      //         bidding_end: biddingEnd
      //     },
      //     onSuccess: this.getSeekerBids.bind(this)
      // });
   }

   revokeWithdrawBid = (e, bid) => {
      e.stopPropagation();
      let trip_bid_end = bid && (bid.round_bidding_end ? bid.round_bidding_end : bid.tripBidEnd);
      if(bid)
      this.props.revokeWithdrawBid(bid.tripId, bid.rfqId, bid.transporterId, trip_bid_end);
   }

   renderCalendarPerTrip = (trip) => {
      const { systemTime } = this.props;
      if (this.state.isChangeBidShown === trip.id) {
         return (
            <OutsideClickHandler onOutsideClick={() => { this.setState({ isChangeBidShown: trip.id }); }}>
               <div className="pl-10 pf col-1 b-0 ht-60 flex flex-middle flex-between box-shadow bg-white">
                  <div className="pa mb-10 pt-10 pl-10 bg-white box-shadow pr-10 ht-400 b-20 wt-max-content triangle-bottom br-5">
                     <CloseIcon className="pa t--15 r--15 curP" onClick={this.hideChangeBidding} />
                     <SingleDatePicker
                        noBorder={true}
                        displayFormat={"DD MMM YYYY"}
                        isOutsideRange={() => false}
                        hideKeyboardShortcutsPanel={true}
                        placeholder={"Bidding End"}
                        numberOfMonths={1}
                        // date={Moment(this.state.biddingEnd ? this.state.biddingEnd : new Date())}
                        date={Moment(this.state.biddingEnd ? this.state.biddingEnd : systemTime)}
                        onDateChange={(biddingEnd) => {
                           const date = biddingEnd.format('YYYY-MM-DD') + ' ' + Moment(this.state.biddingEnd ? this.state.biddingEnd : new Date()).format('HH:mm')
                           this.setState({ biddingEnd: new Date(date).getTime() }, () => {
                              this.props.postBid(trip.id, this.state.biddingEnd);
                           });
                        }}
                        focused={true}
                        onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                     />
                     <TimePicker
                        showSecond={false}
                        // defaultValue={Moment(this.state.biddingEnd ? this.state.biddingEnd : new Date())}
                        defaultValue={Moment(this.state.biddingEnd ? this.state.biddingEnd : systemTime)}
                        className="ht-40 wt-150 border-status-bar br-5"
                        onChange={(biddingEnd) => {
                           // const date = Moment(this.state.biddingEnd ? this.state.biddingEnd : new Date()).format('YYYY-MM-DD') + ' ' + biddingEnd.format('HH:mm')
                           const date = Moment(this.state.biddingEnd ? this.state.biddingEnd : systemTime).format('YYYY-MM-DD') + ' ' + biddingEnd.format('HH:mm')
                           this.setState({ biddingEnd: new Date(date).getTime() }, () => {
                              this.props.postBid(trip.id, this.state.biddingEnd);
                           });
                        }}
                        format={'h:mm a'}
                        use12Hours
                        inputReadOnly
                     />
                     {<button className="pa b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 hCenter" onClick={() => this.updateBiddingEnd(trip)}>Update</button>}
                  </div>
               </div>
            </OutsideClickHandler>
         );
      }
   }
   hasTk11Failed = (bid) => {
      if (bid && bid.tkResponse) {
         let result = false;
         for (let i = 0; i < (bid.tkResponse || []).length; i++) {
            if (bid.tkResponse[i].resCode === 'E') {
               result = true;
               if (result === true) break;
            }
         }
         return result;
      }
   }

	getSlabValue = (from, to) => {
		let value = '';
		if (from && to) {
			value = `${from} - ${to}`;
		} else if (!from && to) {
			value = `${from} - ${to}`;
		} else if (from && !to) {
			value = from
		}
		return value;
	}

   setCurrentIndex(index) {
      this.setState({ currentIndex: index }, () => {
         if (this.state.currentIndex > -1) {
            //this.props.removeOverFlowHidden();
         } else {
           // this.props.setOverFlowHidden();
            this.setState({ openPopup: false });
         }
      });
   }

   saveVehiclePlaced = (data)=>{
   this.props.saveNumberOfVehiclePlaced(data);
   }
   
   cancelledLOI= (e, bids) => {
      const { dispatch } = this.props;
      e.stopPropagation();
      console.log(bids);
     this.setState({
      isLoiCancelPopupShown : true,
      bids 
     })
		
	}

   hideLOICancelPopup = () => {
      this.setState({
         isLoiCancelPopupShown: false,
         loiCancelRemark : ""
      });
   }

   onChangeLoiCancelRemarks = (e) => {
		this.setState({ loiCancelRemark: e.target.value });
   }
   onConfirmCancelLoi=()=>{
      const { dispatch } = this.props;
      const { loiCancelRemark , bids} = this.state;
      let data={
         rfq_id: bids.rfqId,
         trip_id: bids.tripId,
         transporter_id : bids.transporterId,
         loi_cancel_remark: loiCancelRemark,
         ip_address: localStorage.getItem('IPAddress')
		}
		dispatch({
			type: LOI_CANCELLED,
			data
      });
      
      this.setState({
         loiCancelRemark:"",
         isLoiCancelPopupShown: false
      })
   }

   vistaaronChangeSOB = (e, bid, bids) => {
      const { sobValues } = this.state;
      const { rfq, selectedBids } = this.props;
      const presentValue = (sobValues || []).findIndex(el => el.trip_id == bid.tripId && el.transporter_id == bid.transporterId);
      const orderValue = (sobValues || []).find(el => el.orderText === 'L1' && el.trip_id == bid.tripId) || (bids || []).find(el => el.orderText === 'L1');
      let sum = 0;

      if (e.target.value > 100) {
         this.setState({ isSOBPriceUpdated: false });
         return;
      }

      (bids || []).forEach(el => {
         if (el.transporterId !== bid.transporterId) {
            const sobPresent = (sobValues || []).find(sob => sob.trip_id === el.tripId && sob.transporter_id === el.transporterId);
            sum += (sobPresent ? Number(sobPresent['share_of_business_percentage'] || 0) : Number(el['share_of_business_percentage'] || 0));
         } else {
            sum += Number(e.target.value || 0);
         }
      });

      (bids || []).map(el => el.sumOfSOB = sum);

      if (e.target.value && sum > 100) {
         this.setState({ isSOBPriceUpdated: false });
         alert('Sum of SOB should not be more than 100%');
         return;
      }

      if (presentValue > -1) {
         sobValues[presentValue]['share_of_business_percentage'] = e.target.value && Number(e.target.value);
      } else {
         sobValues.push({
            "trip_id": bid.tripId,
            "transporter_id": bid.transporterId,
            "company_id": getUser().companyId,
            "share_of_business_percentage": e.target.value && Number(e.target.value),
            "orderText": bid.orderText,
            "is_accept": bid.isAccept
         });
      }

      this.setState({
         sobValues,
         isSOBPriceUpdated: true
      });

      let isTripPresent = false;
      (selectedBids || []).forEach(el => {
         if (el.tripId === bid.tripId) {
            isTripPresent = true;
            el.sumOfSOB = sum;
            if (bid.transporterId === el.transporterId && !el.share_of_business_percentage) {
               el.share_of_business_percentage = e.target.value && Number(e.target.value);
            }
         }
      });

      if (isTripPresent) {
         this.props.setBids(selectedBids);
      }
   }

   
   getVistaarDefaultSOBValue = (bid, bids) => {
      const { rfq } = this.props;
      const { sobValues } = this.state;

      if (!isVishaka()) {
         return bid.share_of_business_percentage || '';
      }

      
      const existingSOB = (sobValues || []).find(
         el => el.trip_id == bid.tripId && el.transporter_id === bid.transporterId
      );

      if (existingSOB) {
         return existingSOB.share_of_business_percentage;
      }

      if (bid.share_of_business_percentage) {
         return bid.share_of_business_percentage;
      }

      
      const transportersForTrip = (bids || []).filter(b => b.tripId === bid.tripId);


      if (transportersForTrip.length === 1) {
         return 100;
      }

      return '';
   }

   onChangeSOB = (e, bid, bids) => {
      const { sobValues } = this.state;
      const { rfq, selectedBids } = this.props;
      const presentValue =  (sobValues || []).findIndex(el => el.trip_id == bid.tripId && el.transporter_id == bid.transporterId);
      const orderValue = (sobValues || []).find(el => el.orderText === 'L1' && el.trip_id == bid.tripId) || (bids || []).find(el => el.orderText === 'L1');
      let sum = 0;
      if(e.target.value > 100) {
         this.setState({ isSOBPriceUpdated: false });
         return;
      }
      // if(!ROQUETTE.includes(rfq.companyId) && bid.orderText !== 'L1' && orderValue['share_of_business_percentage'] < e.target.value && Number(e.target.value)) {
      //    alert('SOB should be less than L1 SOB');
      //    this.setState({ isSOBPriceUpdated: false });
      //    return;
      // }
      (bids || []).forEach(el => {
         if(el.transporterId !== bid.transporterId) {
            const sobPresent = (sobValues || []).find(sob => sob.trip_id === el.tripId && sob.transporter_id === el.transporterId);
            sum += (sobPresent ? Number(sobPresent['share_of_business_percentage'] || 0) : Number(el['share_of_business_percentage'] || 0));
         } else {
            sum += Number(e.target.value || 0);
         }
      });

      (bids || []).map(el => el.sumOfSOB = sum);
      if(e.target.value && sum > 100) {
         // (((((bids || []).reduce((sum, el) => (sum += el.transporterId !== bid.transporterId ? (el['share_of_business_percentage'] || 0) : 0) ,0) + Number(e.target.value)) > 100)) || (sobValues && sobValues.length > 0 && (((sobValues || []).reduce((sum,el) => sum += ((el.trip_id == bid.tripId && el.transporterId !== bid.transporterId) ? Number(el.share_of_business_percentage || 0) : 0) + Number(e.target.value)),0))) > 100)) {
         this.setState({ isSOBPriceUpdated: false });
         alert('Sum of SOB should not be more than 100%');
         return;
      }
      if(presentValue > -1) {
         sobValues[presentValue]['share_of_business_percentage'] = e.target.value && Number(e.target.value);
      } else {
         sobValues.push({
            "trip_id": bid.tripId,
            "transporter_id": bid.transporterId,
            "company_id": getUser().companyId,
            "share_of_business_percentage": e.target.value && Number(e.target.value),
            "orderText": bid.orderText,
            "is_accept": bid.isAccept
         });
      }
      this.setState({
         sobValues,
         isSOBPriceUpdated: true
      });
      let isTripPresent = false;
      (selectedBids || []).forEach(el => {
         if(el.tripId === bid.tripId) {
            isTripPresent = true;
            el.sumOfSOB = sum;
            if(bid.transporterId === el.transporterId && !el.share_of_business_percentage) {
               el.share_of_business_percentage = e.target.value && Number(e.target.value);
            }
         }
      });
      if(isTripPresent) {
         this.props.setBids(selectedBids);
      }
   }

   postSOB = (bid) => {
      const { sobValues, isSOBPriceUpdated } = this.state;
      const presentValue =  (sobValues || []).findIndex(el => el.trip_id == bid.tripId && el.transporter_id == bid.transporterId);
      if(presentValue > -1 && isSOBPriceUpdated) {
         delete sobValues[presentValue].orderText;
         if(sobValues[presentValue]['share_of_business_percentage'] === '') {
            sobValues[presentValue]['share_of_business_percentage'] = 0;
         }
         this.props.postSOB(sobValues[presentValue]);
      }

   }

   companiesToRenderUploadRemarks = () => {
      const user = getUser();
      const isBeam = BEAM.includes(user.companyId);
      if(isBeam){
         return true;
      }
      return false; 
   }
   companiesToRenderViewRemarks = () => {
      const user = getUser();
      const isBeam = BEAM.includes(user.companyId);
      if(isBeam){
         return true;
      }
      return false; 
   }
   shouldRenderDieselprice = (trip) => {
      const user = getUser();
      const isBeam = BEAM.includes(user.companyId);
      const C1 = trip.biddingDetails.diesel_price;
      if(isBeam && C1){
         return true;
      }
      return false; 

   }

   getCountText = (type) => {
		let countText = 'Trips'; 
		if(type === 9) {
			countText = 'Lanes';
		} else if(type === 8) {
			countText = 'Material Details';
		}
		return countText;
	}

   handleNavigateAuditLogs = (tripId,rfqId) => {
      localStorage.setItem('rfqId', rfqId);
      localStorage.setItem('tripId', tripId);
   };

   shouldRenderSeekerRemarks = (bid) => {
      return (
         bid.seekerInstructions ||
         bid.sent_loi_for_approver_remarks ||
         bid.seekerRemarks
      );
   }

   renderRowItems = (trip, index, hasSubTrips) => {
   
      const { isApprovalMode, selectedBids, hideTransportersName, rfq, isTK11, displayBaseVolume, systemTime, tripBids,fetchBids, currencyDetails, currencyTypes, maxTransportersCountRFQ, bided_transporter_name} = this.props;
      
      const { tripLPP, sobValues } = this.state;
      const dashboardActiveView = this.props.dashboardActiveView ? this.props.dashboardActiveView : getDashboardActiveView();
      const isApproveOfLoi = (dashboardActiveView === 10);
      const isApproveMessage = (dashboardActiveView === 10) || (dashboardActiveView === 12);
      const user = getUser();
      const isACC = (user.companyId === ACC);
      const isCargil = CARGIL.includes(user.companyId);
      const beam = BEAM.includes(user.companyId);
      const isPolycab = POLYCAB.includes(user.companyId);
      const isShowLppDetail = user.showLppDetails;
      let isTripMessage = (rfq.trips.length === 1) ? 'This Is The Only Trip. If You Delete It, RFQ Will Be Cancelled. Are You Sure You Want To Delete It?' : 'Are You Sure You Want To Delete This Trip?';
      const tripCurrencyType = (currencyTypes || []).find(el => el.currency_name === (trip.legCostName !== 'INR' ? trip.legCostName : trip.priceInBaseCurrency)) || {};
      // console.log(trip.isWithDrawBid + "iswithdraw")
      const isAdaniCompleteSolution = (isAdaniWilmar() && rfq.type === 3 && rfq.rfqDetails.secondaryContractType === 2 && !rfq.rfqDetails.acceptPartialSolution);
      const isEmamiCompleteSolution = ([...EMAMI, ...STAR_CEMENT,...GREEN_PLY].includes(user.companyId) && rfq && !rfq.rfqDetails.acceptPartialSolution);
      const isRoquette = ROQUETTE.includes(user.companyId);
      const isRoquetteBidEnd = (isRoquette && (rfq.rfqDetails.biddingEnd < systemTime));
      const sortedBidsLTC  = (isAdaniCompleteSolution || isRoquetteBidEnd) ? (trip.bids || []).sort((a, b) => (a[isRoquetteBidEnd ? 'sum_order_text' : 'freight_rate_order'] - b[isRoquetteBidEnd ? 'sum_order_text' : 'freight_rate_order'])) : (rfq.rfqTypeLtc == "LTC" ? (trip.bids || []).sort((a, b) => (a.ltc_order - b.ltc_order)) : (isEmamiCompleteSolution ? (trip.bids || []).sort((a, b) => (a.sum_order - b.sum_order)) : (trip.bids || [])));
      let sobInputReadOnly = false;
      const isEditCP = (user.actions || []).find(action => [1,3].includes(action.id))
      if(rfq && rfq.shareOfBusiness) {
         const loiSentBids = (sortedBidsLTC || []).filter(bid =>(bid.sumOfSOB === 100 && bid['share_of_business_percentage'] && bid.isLoiSent));
         if(loiSentBids.length > 0) {
            const loiAcceptBids = (sortedBidsLTC || []).filter(bid =>(bid.sumOfSOB === 100 && bid['share_of_business_percentage'] && bid.isLoiSent && bid.isAccept));
            if(loiSentBids.length === loiAcceptBids.length) {
               sobInputReadOnly = true
            }
         }
      }

      const activeBids = (sortedBidsLTC || [])
         .filter(el => el.id)
         .filter(bid => !bid.isWithDrawBid || bid.isAccessBidWithdrawn);

      const maxActiveBidCount = rfq.isEnableWithdrawBid ? (this.props.trips || []).reduce((max, t) => {
         if ((t.subTrips || []).length > 0) {
            let subMax = 0;
            (t.subTrips || []).forEach(st => { subMax = Math.max(subMax, (st.bids || []).length); });
            return Math.max(max, subMax);
         }
         const aCount = (t.bids || []).filter(b => b.id && (!b.isWithDrawBid || b.isAccessBidWithdrawn)).length;
         return Math.max(max, aCount);
      }, 0) : 0;

      return (
         <Fragment>
            <div className="flex flex-middle border-top-light pt-25 pb-25 pr col-1 fRegular">
               {!isTK11 && !trip.isWithDrawBid && !(rfq.type === 1 && ['737'].includes(rfq.companyId)) && ([...EMAMI, ...STAR_CEMENT,...GREEN_PLY].includes(user.companyId) ? !isEmamiCompleteSolution : true) && <Checkbox
                  type="square"
                  onCheck={this.toggleAllBids.bind(this, trip)}
                  className="wt-70"
                  checked={trip.bids.length > 0 && ((selectedBids || []).filter((selectedBid) => {
                     return selectedBid && (selectedBid.tripId === trip.id);
                  }).length) === (trip.bids || []).length}
                  isBids="true" />}
               <div className={Classname("fs-14 table-text-color break-word", {
                  'wt-150': ([...EMAMI, ...STAR_CEMENT,...GREEN_PLY].includes(user.companyId) ? !isEmamiCompleteSolution : true),
                  'wt-200': isEmamiCompleteSolution
               })}>
                  {trip.container_type_name  && <div className="theme-color mb-5">{trip.container_type_name}</div>}
                  <div>
                     {(trip.from && trip.to && !rfq.enableRouteDescription) ?
                     <span>
                        {!user.showPinCodeDetails ?
                        <>{GALAXY_SURFACE.includes(user.companyId) ?
                           <>
                              {
                                 (trip.ftlStops || []).map((stop, index)=> {
                                    return (
                                       <span>{(stop.location && (stop.location.split(',') || [])[0] || stop.city)}{(((trip.ftlStops || []).length - 1) !== index) ? <BackIcon className="wt-10 ml-5 mr-5 mt-5 rotate-180deg" /> : ''}</span>
                                    )
                                 })
                              }
                          </> :
                        <>{trip.from + ' - ' + trip.to}</>}</> :
                        <>{`${trip.from}${trip.stops.length > 0 && trip.stops[0].pincode && ` (${trip.stops[0].pincode}) `} - ${trip.to}${(trip.stops || []).length > 1 && trip.stops[1].pincode && ` (${trip.stops[1].pincode}) `}`}</>
                        }
                     </span> 
                     : (rfq.enableRouteDescription)? <span> {trip.to} </span> :
                     <span>
                        {trip.from}
                     </span>
                     }
                     {(CARGIL.includes(rfq.companyId) && trip.consigneeTypeName) && <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5">
                     <span>Consignee Type : </span><span className='theme-color'>{trip.consigneeTypeName}</span>
                  </div> || null}
                     {rfq && (rfq.multiLevelMovementType === 2) && trip.multi_mode_leg_trip[0] && <span className="theme-color">(Leg {trip.multi_mode_leg_trip[0].leg_no})</span>}
                  </div>
                  {(rfq && rfq.type === 1 && isAdaniWilmar()) && <div><span className='fBold theme-color'>Contract Type: </span><span>{trip.contract_type_name}</span></div>}
                  {isDesmet() && ((trip.consigners || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignor: </span><span>{`${((trip.consigners || [])[0] || {}).company_name}, ${((trip.consigners || [])[0] || {}).address}`}</span></div>}
                  {isDesmet() && ((trip.consignees || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignee: </span><span>{`${((trip.consignees || [])[0] || {}).company_name}, ${((trip.consignees || [])[0] || {}).address}`}</span></div>}
                  {rfq && (rfq.rfqDetails || {}).ftlContractType === 2 && <div>
                     <span className='fBold'>Slab: </span> <span>{trip.fromRange + ' - ' + trip.toRange}</span>
                  </div> || ''}

                  {trip.slab_name && <div className='mt-5'>
                        <span className='fBold theme-color'>{`Slab${trip.pricingBasisName ? `(${trip.pricingBasisName})` : ''}: `}</span> <span>{trip.slab_name}</span>
                     </div> || ''}
                  {rfq.type === 8 &&
                     <>
                        <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                           Quantity:  <span className="fBold">{trip.total_estimated_qty}</span>
                        </div>
                        <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                           UOM:  <span className="fBold">{trip.uom}</span>
                        </div>
                     </>
                  }
                  {rfq.type === 3 && isAdaniWilmar() && (rfq.rfqDetails || {}).secondaryContractType === 1 &&
                     <>
                        <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                           Carrying Capacity(MT):  <span className="fBold">{trip.carryingCapacity}</span>
                        </div>
                        <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                           Fixed km/Month:  <span className="fBold">{trip.fixedKmPerMonth}</span>
                        </div>
                        {/* <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                           Extra Cost Per km :  <span className="fBold">{trip.extraCostPerKm}</span>
                        </div> */}
                     </>
                  }
                  {trip.multi_mode_leg_trip[0] && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                     {trip.multi_mode_leg_trip[0].leg_type_name}
                  </div>
                  }
                  {trip.rfqType === 6 && <div className="section-sub-header-color fs-12 op-79 lh-15p">{`( ${trip.legName} )`}</div>}
                  {trip.biddingDetails.businessVolumeValue ? <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5">
                     {isAdaniWilmar() && trip.rfqType === 3 ? 'Business Volume(MT): ' : ([...CENTURY_PLY, ...CARGIL].includes(rfq.companyId) ? 'Business Volume: ': '')} {trip.biddingDetails.businessVolumeValue}  {trip.biddingDetails.businessVolumeUnitName}
                  </div> : null}
                  {((trip.noOfPickups > 1 || trip.noOfDrops > 1)) ? <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5"><span className="vehicle-pickup-drop-span">{trip.noOfPickups} {'Pickups |'} {trip.noOfDrops} {'Drops'}</span>
                     <a data-tip data-for={`scrollContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                     <ReactTooltip
                        id={`scrollContent-${index}`}
                        type="light"
                        effect="solid"
                        place="right"
                        className="tooltip-trip-shadow"
                        delayHide={100}
                     >
                        <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                           <section className="flex mt-25 flex-column">
                              <RFQFTLTripsTable lineItem={trip} />
                           </section>
                        </div>
                     </ReactTooltip>
                     </div> : null}
                  {(trip.vehicleTypeName || trip.vehicleBodyTypeName) && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                     {trip.vehicleTypeName}, <span>{trip.vehicleBodyTypeName}</span>
                  </div>}
                  {trip.outboundDelivery && <div className="theme-color">OBD No: {trip.outboundDelivery}</div>}
                  {trip.qty && <div className="theme-color">OBD Qty : {trip.qty} {(trip.celingPriceUnit)}</div>} 
                  {DALMIA_CEMENT.includes(user.companyId) ? <>(trip.isBags === 1 ) ? <div className="theme-color">Bags: {trip.bags} </div> : (trip.isBags === 2 ) ?<div className="theme-color">Bulk : {trip.isBulk} </div> : {""}</> : ''}
                  {isPolycab && <>
                     {trip.shipment_id && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">Shipment ID: {trip.shipment_id} {` (${trip.shipment_status})`} </div>}
                  </>}
                  {trip.rfqType === 6 && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">{trip.multi_mode_movement_type}</div>}
                  {trip.secKmRun && !isACC && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                     KM Run - {trip.secKmRun}
                  </div>}
						{trip.secUptoKM >=0 && !isACC && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                     Minimum Km - {trip.secUptoKM}
                     
                  </div>}

                  {trip.tripContractTenureFrom && <span className="fs-12 table-text-color op-79 lh-15p pb-5">  {Moment(trip.tripContractTenureFrom).format('Do MMM, YYYY h:mm:ss a')} </span> } 
                  {trip.tripContractTenureTo &&<span className="fs-12 table-text-color op-79 lh-15p pb-5">To  {Moment(trip.tripContractTenureTo).format('Do MMM, YYYY h:mm:ss a')} </span>}
                  {(trip.tripContractTenureTo && trip.tripContractTenureTo  > new Date()) ? <span className='fs-14 fBold success-color'>Active</span> : (trip.tripContractTenureTo && trip.tripContractTenureTo  < new Date()) ? <span className='fs-14 fBold error-color'> Expired </span>:""}

                  {rfq && rfq.rfqStatus === 5 && trip.placedNumberOfTrucks >0 && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                  Placed No Of Vehicle - {trip.placedNumberOfTrucks}
                  </div>}
                  {
                     trip.headingChargesMr && <div className="section-sub-header-color fs-12 mt-5 op-79"><b>RR:</b> {trip.headingChargesMr}</div>
                  }
                  {
                     trip.headingChargesLpp && <div className="section-sub-header-color fs-12 mt-5 op-79"><b>LPP:</b> {trip.headingChargesLpp}</div>
                  }
                  {
                     trip.totalBudget && <div className="section-sub-header-color fs-12 mt-5 op-79"><b>Budget:</b> {trip.totalBudget}</div>
                  }
                  {
                     // <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                     //     {(tripLPP[trip.id] && tripLPP[trip.id].distance) ? tripLPP[trip.id].distance : ''} {' '}
                     //     {(tripLPP[trip.id] && tripLPP[trip.id].distance_uom) ? tripLPP[trip.id].distance_uom : ''}
                     // </div>
                  }
                  {
                     trip.distance && !isACC &&
                     <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                        {(trip.distance) ? trip.distance : ''} {' '} {(trip.distanceUOM) ? trip.distanceUOM : (trip.rfqType === 6 ? "Km" : "")} {' '} {(trip.is_km_inserted_by) ? `(${trip.is_km_inserted_by})` : ''}
                     </div>
                  }
                  {
                     ([...DEEPAK_PHENOLICS_SAP, ...DEEPAK_PHENOLICS].includes(rfq.companyId)) &&
                     (rfq?.is_rfq_price_update || rfq?.is_rfq_toll_price_update) && (
                        <div>

                           {/* Tooltip Trigger Icon */}
                           <Link
                              to="/auditDashboard"
                              onClick={() => this.handleNavigateAuditLogs(trip.id, rfq.id)}
                           >
                              <SEOIcon
                                 className="curP fBold fs-18 wt-20 ht-30"
                                 data-tip
                                 data-for={`revised-price-tooltip-${rfq.id}`}
                              // onClick={() => this.handleNavigateAuditLogs(trip.id, rfq.id)}
                              />

                              {/* Tooltip */}
                              <ReactTooltip
                                 id={`revised-price-tooltip-${rfq.id}`}
                                 type="dark"
                                 effect="solid"
                                 place="top"
                              >
                                 <span>
                                    Revised Price logs
                                 </span>
                              </ReactTooltip>
                           </Link>
                        </div>
                     )
                  }
                  <div> {trip.productCategoryTypeName} </div>
                  {
                     trip.relayEndTime &&
                     // trip.relayEndTime >= new Date().getTime() &&
                     // trip.biddingDetails.to < new Date().getTime() &&
                     trip.relayEndTime >= systemTime &&
                     trip.biddingDetails.to < systemTime &&
                     <Timer
                        from={trip.biddingDetails.to}
                        to={trip.relayEndTime}
                        // currentTime={new Date().getTime()}
                        currentTime={systemTime}
                        isRelayBid={true}
                     />
                  }
                  {trip.trip_bidding_end && trip.trip_bidding_end >= systemTime &&
                     <Timer
                        from={trip.biddingDetails.to}
                        to={trip.trip_bidding_end}
                        // currentTime={new Date().getTime()}
                        currentTime={systemTime}
                        isRelayBid={true}
                     />
                  }
                  {(rfq.rfq_re_bidding_end > systemTime && trip.trip_re_bidding) && <div className="fs-14 fBold mt-5 mb-5 success-color">{'Bidding Reopened'}</div>}
                  {![8].includes(rfq.type) && <div className="fs-12 curP theme-color fSemibold mt-5 mb-8" onClick={this.showTripDetail.bind(this, trip, false)}>View More</div>}
                  {isVishaka() &&
                     <div className="flex flex-middle">
                        <a
                           href={`https://datastudio.google.com/embed/reporting/01363cb7-6dd9-446d-af48-360d207d3944/page/p_jlp47aoh2d?params=${encodeURIComponent(JSON.stringify({ route_name_param: `${trip.from} - ${trip.to}`, rfq_number_param: rfq.rfqNumber, vehicle_type_param: trip.vehicleTypeName }))}`}
                           target="_blank"
                           rel="noopener noreferrer"
                           className="fs-14 fSemibold contract-summary-link curP"
                        >
                           Contract Summary
                        </a>
                     </div>
                  }
                  {[1,12].includes(rfq.type) && this.companiesToRenderUploadRemarks() &&<div className="fs-12 curP theme-color fSemibold mt-5 mb-8" onClick={this.showUploadfilePopup.bind(this, trip, false)}>Upload File</div>}
                  {[1,12].includes(rfq.type) && this.companiesToRenderViewRemarks()  &&<div className="fs-12 curP theme-color fSemibold mt-5 mb-8" onClick={this.showViewLOIRemarksPopup.bind(this, trip, false)}>View LOI,Remarks</div>}
                  {/*<div className="fs-12 curP theme-color fSemibold" onClick={this.showTripDetail.bind(this, trip, true)}>View Charges</div>*/}
                  {user && user.uploadNumberOfTrucks && rfq && rfq.rfqStatus === 5 && <div>
                  <NumberOfVehiclePlaced
                  index ={index}
                  placedNumberOfTrucks={trip.placedNumberOfTrucks}
                  trip ={trip}
                  saveVehiclePlaced={(data) => { this.saveVehiclePlaced(data)}}
                  />
                  </div>}
                  
               </div>

               {trip.rfqType === 6 && <div className="fs-14 table-text-color wt-120 pl-15 break-all">
                  <span>{trip.providerName}</span>
                  <div>{['Plant To Yard', 'Plant To Port'].includes(trip.legName) ? `at ${trip.from}` : (['Yard To Depot', 'Port To Depot'].includes(trip.legName) ? `at ${trip.from}` : '')}</div>
                  <div className="fs-12 mt-5">Remarks: {trip.multiModeRemarks}</div>
                  {trip.noOfManPower && <div className="fs-12 mt-5">Man Power: {trip.noOfManPower}</div>}
               </div>}
               
               <div className="fs-14 table-text-color wt-100 pl-15">{trip.l1Hits || 0} <b className="theme-color">|</b> {trip.hits}</div>
               <div className={Classname("fs-14 table-text-color pl-15", {
                  'wt-300': (trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)),
                  'wt-200': (trip.rfqType !== 5 && ![13,14,15].includes(trip.rfqType))
               })}>
						<div className="mb-5">
							{trip.rfqType !== 6 && 
                     <div className="fs-14 flex">
                        <Fragment>
								<span className={Classname("label-color", {
                           'wt-72': trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)
                        })} title={(trip.rfqType === 5 || trip.rfqType === 2 || [13,14,15].includes( trip.rfqType)) ? 'Total Price :' : 'Ceiling Price :'}>{(trip.rfqType === 5 || trip.rfqType === 2 || [13,14,15].includes( trip.rfqType)) ? 'Total Price :' : 'Ceiling Price :' }
									{/*{trip.rfqType === 5 && <span className={'theme-color fs-12 fBold'}>{rfq.rfqDetails.otherCosts && '(Includes Other Costs)' || '(Excludes Other Costs)'}</span>}*/}
								</span>                       
                        {((HIKAL.includes(user.companyId) && trip.rfqType === 5) || [13,14,15].includes( trip.rfqType)) ?
                        <>
								   <span className="header-medium-color fSemibold wt-100 mt--3" title={`₹${trip.leg_budget_cp_inr}`}>₹{trip.leg_budget_cp_inr && Number(trip.leg_budget_cp_inr).toFixed(2)}{((trip.rfqType === 5 && HIKAL.includes(user.companyId)) || [13,14,15].includes( trip.rfqType)) &&  <a data-tip data-for={trip.id}><span className="tooltip-icon fBold">c</span></a>}</span>
								   {trip.leg_cost_name !== 'INR' && 
                           <>  
                              {rfq.rfqDetails.otherCosts ?
                              <span className="header-medium-color fSemibold ml-6 wt-100" title={`${((currencyTypes || []).find(el => el.currency_name === trip.leg_cost_name) || {}).currency_symbol || ''}${trip.biddingDetails[`qbr_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`] && Number(trip.biddingDetails[`qbr_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`]).toFixed(2)}`}>{trip.biddingDetails[`qbr_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`] && `${((currencyTypes || []).find(el => el.currency_name === trip.leg_cost_name) || {}).currency_symbol || ''}${trip.biddingDetails[`qbr_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`] && Number(trip.biddingDetails[`qbr_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`]).toFixed(2)}`}</span> 
                              :
                              <span className="header-medium-color fSemibold ml-6 wt-100" title={`${((currencyTypes || []).find(el => el.currency_name === trip.leg_cost_name) || {}).currency_symbol || ''}${trip[`leg_budget_cp_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`] && Number(trip[`leg_budget_cp_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`]).toFixed(2)}`}>{`${((currencyTypes || []).find(el => el.currency_name === trip.leg_cost_name) || {}).currency_symbol || ''}${trip[`leg_budget_cp_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`] && Number(trip[`leg_budget_cp_${trip.leg_cost_name === "USD" ?  'usd' : 'secondary'}`]).toFixed(2)}`}</span>}
                           </>}
                        </>
                        :<>
								   <span className={`header-medium-color fSemibold wt-100 ${rfq.type === 8 ? 'mt-2' :'mt--3'}`} title={`${rfq.type === 8 ? ' ' : '₹'}{${(((trip.rfqType === 5 && (HIKAL.includes(user.companyId)) || [13,14,15].includes( trip.rfqType)) ? trip.priceInBaseCurrency !== 'INR' : true)) ? trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}inr`] :trip.biddingDetails.qbr}`}>{rfq.type === 8 ? ' ' : '₹'}{((trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) && ((HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType)) ? trip.priceInBaseCurrency !== 'INR' : true)) ? (trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}inr`] && Number(trip.biddingDetails[`qbr_${(trip.rfqServiceType === 5 && ((HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType)) ? trip.priceInBaseCurrency !== 'INR' : true)) ? 'volume_' : ''}inr`]).toFixed(2)) :trip.biddingDetails.qbr}{((trip.rfqType === 5 && HIKAL.includes(user.companyId)) || [13,14,15].includes(trip.rfqType)) &&  <a data-tip data-for={trip.id}><span className="tooltip-icon fBold">c</span></a>}</span>
								   {(trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) && trip.priceInBaseCurrency !== 'INR' && <span className="header-medium-color fSemibold ml-6 wt-100" title={`${trip.priceInBaseCurrencySymbol || ''}${trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}${trip.priceInBaseCurrency === "USD" ?  'usd' : 'secondary'}`]}`}>{trip.priceInBaseCurrencySymbol || ''}{trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}${trip.priceInBaseCurrency === "USD" ? 'usd' : 'secondary' }`] && Number(trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}${trip.priceInBaseCurrency === "USD" ? 'usd' : 'secondary' }`]).toFixed(2)}</span>}
                        </>}
                        {((trip.rfqType === 5 && HIKAL.includes(user.companyId)) || [13,14,15].includes( trip.rfqType)) && <ReactTooltip id={trip.id} type="dark" effect="solid" place={[13,14,15].includes( trip.rfqType) ? "bottom" : "top"}>
                           <CostHeadCalculation data={trip.multiModeHeadingCharges || []} />
                        </ReactTooltip>}
                     </Fragment>
							</div>}
                     
                     {trip.qbr_budget_diff && <div className='mt-10 mb-10'>Budget Diff:{trip.qbr_budget_diff||''}</div>}
                     { this.shouldRenderDieselprice(trip) &&<div className='mt-10 mb-10'>Diesel Price:{trip.biddingDetails.diesel_price||''}</div>}
                     {(beam && (trip.biddingDetails || {}).budget) && <div className="label-color mt-5">Budget : ₹{(trip.biddingDetails || {}).budget}</div> || ''}
                     { trip.rfqType === 6 &&
                        <div className="fs-14 flex">
                           {(trip.legName === "Yard To Yard (BCN)") ?
                              <Fragment>
                                 {/* <span className={Classname("label-color")} title={'Freight (Train)'}>{'Freight (Tarin) :'} </span><br/> */}
                                 <span className={Classname("label-color")} title={'Freight'}>{'Freight :'} </span>
                              </Fragment>
                              :
                              <span className={Classname("label-color")} title={'Ceiling Price'}>{'Ceiling Price :'}</span>
                           }
                           { trip.legName === "Yard To Yard (BCN)" ? 
                              <Fragment>
                                 {/* <span className="header-medium-color fSemibold wt-100 mt--3">{trip.freightValue && trip.freightValue.length > 0 && `₹${trip.freightValue[trip.freightValue.length-1]["Train Load"]}`}</span><br/> */}
                                 <span className="header-medium-color fSemibold wt-100 mt--3">{trip.freightValue && trip.freightValue.length > 0 && `₹${trip.freightValue[trip.freightValue.length-1]["Wagon Load"]}`}</span>  
                              </Fragment>
                              :
                              <span className="header-medium-color fSemibold wt-100 mt--3" title={`₹${trip.biddingDetails.qbr || trip.qbr || ''}`}> ₹{trip.biddingDetails.qbr || trip.qbr || ''}</span>}
                        </div>
                     }
							{(trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) && <span className={'theme-color fs-12 fBold'}>{rfq.rfqDetails.otherCosts && '(Includes Other Costs)' || '(Excludes Other Costs)'}</span>}
						</div>
                  { (trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) &&
                     (trip.multi_mode_leg_trip || []).map((buget) => {
                        const currencyType = (currencyTypes || []).find(el => el.currency_name === (buget.leg_cost_name !== 'INR' ? buget.leg_cost_name : buget.price_in_base_currency) ) || {};
                        return(
                           <div className="mb-5 fs-13 flex">
                           <span className="label-color fs-13 mt--2 wt-61">Base Cost: </span>
                           {buget.leg_budget_cp_inr && <span className="fBold wt-100 mt--3 mr-5 ml-5" title={`₹${buget.leg_budget_cp_inr}`}>₹{buget.leg_budget_cp_inr && Number(buget.leg_budget_cp_inr).toFixed(2)}</span>}
                           {trip.priceInBaseCurrency !== 'INR' && buget[`leg_budget_cp_${currencyType.currency_name === 'USD' ? 'usd' : 'secondary' }`] && <span className="fBold ml-5 wt-100" title={`${currencyType.currency_symbol}${buget[`leg_budget_cp_${currencyType.currency_name === 'USD' ? 'usd' : 'secondary'}`]}`}>{currencyType.currency_symbol || ''}{buget[`leg_budget_cp_${currencyType.currency_name === 'USD' ? 'usd' : 'secondary'}`] && Number(buget[`leg_budget_cp_${currencyType.currency_name === 'USD' ? 'usd' : 'secondary'}`]).toFixed(2)}</span>}
                           </div>
                        )
                     })
                  }
                  {
                     rfq &&
                     // rfq.rfqDetails.biddingEnd < new Date().getTime() && 
                     (rfq.rfqDetails.biddingEnd < systemTime) &&
                     (trip.rfqType === 2 || trip.rfqType === 3 || (trip.rfqType === 5 && !(HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType))) || (trip.rfqType === 6 && trip.legName !== "Yard To Yard (BCN)")) &&
                     <div className="mb-5 mt-5 flex">
                        <span className="label-color fs-12 wt-60">Challenge Price: </span>
                        {(trip.rfqType === 2 || trip.rfqType === 3 || (trip.rfqType === 6 && trip.legName !== "Yard To Yard (BCN)")) && 
                        <span className="flex header-medium-color fSemibold ml-5">
                           ₹ <input
                              className="ht-20 fSemiBold border-bottom-light-2 wt-60"
                              placeholder="CP"
                              value={this.state.cpvalue[trip.id] || ''}
                              onChange={(e) => {
                                 const { cpvalue } = this.state;
                                 cpvalue[trip.id] = e.target.value;
                                 this.setState({ cpvalue });
                              }}
                              onBlur={(e) => {
                                 if (this.state.cpvalue[trip.id] && this.state.cpvalue[trip.id].length > 0) {
                                    this.toggleAllBids(trip);
                                 }
                              }}
                              readOnly={!isEditCP}
                           />
                           {
                              this.state.cpvalue[trip.id] &&
                              <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                 onClick={() => {
                                    this.props.submitPrice(this.state.cpvalue[trip.id], trip)
                                    this.setState({ cpvalue: {} });
                                 }}
                              >
                                 Send
                              </span>
                           }
                           </span>}
                           {(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) &&
                              <div className="flex header-medium-color fSemibold ml-5 wt-200">
                                 <span className="wt-100">
                              ₹<input
                                 className={Classname("ht-20 fSemiBold border-bottom-light-2 wt-60", {
                                    'disabled': (trip.legs && trip.legs[0] && ["USD", "EUR"].includes(trip.legs[0].legCostName))
                                 })}
                                 placeholder="CP"
                                 value={this.state.cpvalue[trip.id] || ''}
                                 onChange={(e) => {
                                    const { cpvalue, cpvalueUSD, cpvalueSecondary } = this.state;
                                    const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (tripCurrencyType.currency_type === 3 ? 'EUR to INR' : 'USD to INR'));
                                    cpvalue[trip.id] = e.target.value;
                                    if(tripCurrencyType.currency_type === 3 ) {
                                       cpvalueSecondary[trip.id] = conversionUSDObj && (e.target.value / conversionUSDObj.rupee).toFixed(5) || e.target.value;
                                    } else {
                                       cpvalueUSD[trip.id] = conversionUSDObj && (e.target.value / conversionUSDObj.rupee).toFixed(5) || e.target.value;
                                    }
                                    this.setState({ cpvalue , cpvalueUSD, cpvalueSecondary });
                                 }}
                                 onBlur={(e) => {
                                    if (this.state.cpvalue[trip.id] && this.state.cpvalue[trip.id].length > 0) {
                                       this.toggleAllBids(trip);
                                    }
                                 }}
                              />
                              </span>
                              {tripCurrencyType.currency_name !== 'INR' &&<span className="wt-100 ml-15">
                              {tripCurrencyType.currency_symbol || ''}<input
                                 className={Classname("ht-20 fSemiBold border-bottom-light-2 wt-60", {
                                    'disabled': (trip.legs && trip.legs[0] && trip.legs[0].legCostName === "INR")
                                 })}
                                 placeholder="CP"
                                 value={this.state[`cpvalue${tripCurrencyType.currency_name === 'USD' ? 'USD' : 'Secondary'}`][trip.id] || ''}
                                 onChange={(e) => {
                                    const { cpvalue, cpvalueUSD, cpvalueSecondary } = this.state;
                                    const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (tripCurrencyType.currency_name === 'EUR' ? 'EUR to INR' : 'USD to INR'));
                                    cpvalue[trip.id] = conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5) || e.target.value;
                                    if(tripCurrencyType.currency_name=== 'EUR') {
                                       cpvalueSecondary[trip.id] = (e.target.value);
                                    } else {
                                       cpvalueUSD[trip.id] = (e.target.value);
                                    }
                                    this.setState({ cpvalue , cpvalueUSD, cpvalueSecondary});
                                 }}
                                 onBlur={(e) => {
                                    if (this.state.cpvalue[trip.id] && this.state.cpvalue[trip.id].length > 0) {
                                       this.toggleAllBids(trip);
                                    }
                                 }}
                              />
                              </span>}
                              {
                                 this.state.cpvalue[trip.id] &&
                                 <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                    onClick={() => {
                                       this.props.submitPrice(this.state.cpvalue[trip.id], trip, this.state.cpvalueUSD[trip.id], this.state.cpvalueSecondary[trip.id])
                                       this.setState({ cpvalue: {} , cpvalueUSD: {}, cpvalueSecondary: {}});
                                    }}
                                 >
                                    Send
                                 </span>
                              }
                           </div>}
                     </div>
                  }
                   { trip.rfqType === 3 && isAdaniWilmar() && (rfq.rfqDetails || {}).secondaryContractType === 1 &&
                        <div className="fs-14 flex">
                           <span className={Classname("label-color")} title={'Extra Cost / km'}>{'Extra cost/km: '}</span>
                           <span className="header-medium-color fSemibold mt--3 ml-5">{trip.extraCostPerKm && ` ₹${trip.extraCostPerKm}` || ''}</span> 
                        </div>
                     }
                  {
                     rfq &&
                     // rfq.rfqDetails.biddingEnd < new Date().getTime() && 
                     (rfq.rfqDetails.biddingEnd < systemTime) &&
                     (trip.rfqType === 3 && isAdaniWilmar() && trip.extraCostPerKm && (rfq.rfqDetails || {}).secondaryContractType === 1) &&
                     <div className="mb-5 mt-5 flex">
                        <span className="label-color fs-12 wt-60 truncate-long-text" title={'Extra cost/km CP: '}>Extra cost/km CP: </span>
                        <span className="flex header-medium-color fSemibold ml-5">
                           ₹ <input
                              className="ht-20 fSemiBold border-bottom-light-2 wt-60"
                              placeholder="CP"
                              value={this.state.cpExtraCostvalue[trip.id] || ''}
                              onChange={(e) => {
                                 const { cpExtraCostvalue } = this.state;
                                 cpExtraCostvalue[trip.id] = e.target.value;
                                 this.setState({ cpExtraCostvalue });
                              }}
                              onBlur={(e) => {
                                 if (this.state.cpExtraCostvalue[trip.id] && this.state.cpExtraCostvalue[trip.id].length > 0) {
                                    this.toggleAllBids(trip);
                                 }
                              }}
                           />
                           {
                              this.state.cpExtraCostvalue[trip.id] &&
                              <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                 onClick={() => {
                                    this.props.submitOtherCostPrice(this.state.cpExtraCostvalue[trip.id], 'extra_cost_list', trip);
                                    this.setState({ cpExtraCostvalue: {} });
                                 }}
                              >
                                 Send
                              </span>
                           }
                        </span>
                     </div>
                  }
                  {
                     (trip.slabs || []).map((head) => {
                           return (
                              <div className="">
											{/*{(head.toKm) ?
                                 <span className="header-medium-color fSemibold fs-13 mb-5"> {head.costChargeDesc} 
												({head.fromKm} - {head.toKm}) 
												: <span className={'fBold'}>₹{head.qbr}</span></span> : <span className="header-medium-color fSemibold fs-13 mb-5"> {head.costChargeDesc}
													({head.fromKm})
												: <span className={'fBold'}>₹{head.qbr}</span></span>}*/}
											<div className="fs-14 fBold"> {head.costChargeDesc} ({this.getSlabValue(head.fromKm, head.toKm)}) : ₹{head.qbr}</div>
											
                                 {rfq &&
                                 // rfq.rfqDetails.biddingEnd < new Date().getTime() && 
                                 (rfq.rfqDetails.biddingEnd < systemTime) &&
                                 (trip.rfqType === 3) &&
                                 <div className="mb-5">
                                    {/* <span className="table-text-color fs-12">{`${head.costChargeDesc} CP: ` } </span> */}
                                    <span className="flex header-medium-color fSemibold">
                                       ₹ <input
                                          className="ht-20 fSemiBold border-bottom-light-2 wt-60"
                                          placeholder="CP"
                                          value= {((this.state.slabCPValue || []).find(slabValue => slabValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue || ''}
                                          onChange={(e) => {
                                             const { slabCPValue } = this.state;
                                             if(!(slabCPValue || []).find(slabValue => slabValue['cost_charge_id'] === head['cost_charge_id'])) {
                                                slabCPValue.push({
                                                   cost_charge_id: head.cost_charge_id,
                                                   cpvalue: e.target.value
                                                })
                                             } else {
                                                (slabCPValue || []).forEach(slabValue => {
                                                   if(slabValue['cost_charge_id'] === head['cost_charge_id']) {
                                                      slabValue.cpvalue = e.target.value;
                                                   }
                                                })
                                             }
                                             this.setState({ slabCPValue });
                                          }}
                                          onBlur={(e) => {
                                             if (((this.state.slabCPValue || []).find(slabValue => slabValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue) {
                                                this.toggleAllBids(trip);
                                             }
                                          }}
                                       />
                                       {
                                          ((this.state.slabCPValue || []).find(slabValue => slabValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue  &&
                                          <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                             onClick={() => {
                                                this.props.submitOtherCostPrice(this.state.slabCPValue, 'variable_cost_list')
                                                this.setState({ slabCPValue: [] });
                                             }}
                                          >
                                             Send
                                          </span>
                                       }
                                    </span>
                                 </div>}
                              </div>
                           )
                        // }
                        // return null;
                     })
                  }
                  {
                     (trip.multiModeHeadingCharges || []).map((head) => {
                        const currencyType = (currencyTypes || []).find(el => el.currency_type === (head.headingChargesUnit !== 1 ? head.headingChargesUnit : tripCurrencyType.currency_type)) || {};
                        if (head.headingChargesValue) {
                           return (
                              <Fragment>
                              {(trip.rfqType === 2 || trip.rfqType === 3) && <div className="fs-14">
                                 <span className="header-medium-color fBold fs-14 mb-5"> 
                                 <span className="label-color wt-60">{head.headingChargesValue} : </span>
                                 <span className={'fBold'}>₹{head.headingChargesBudget}</span></span>
                                 {rfq &&
                                 // rfq.rfqDetails.biddingEnd < new Date().getTime() && 
                                 (rfq.rfqDetails.biddingEnd < systemTime) &&
                                 (trip.rfqType === 2 || trip.rfqType === 3) &&
                                 <div className="mb-5 flex">
                                    <span className="table-text-color fs-12 mt-2 wt-60 truncate-long-text" title={`${head.headingChargesValue} CP: `}>{`${head.headingChargesValue} CP: ` } </span>
                                    <span className="flex header-medium-color fSemibold ml-5">
                                       ₹ <input
                                          className="ht-20 fSemiBold border-bottom-light-2 wt-60"
                                          placeholder="CP"
                                          // value={this.state.headingCostCPValue[0]['cost_charge_id'] || ''}
                                          value= {((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue || ''}
                                          onChange={(e) => {
                                             const { headingCostCPValue } = this.state;
                                             if(!(headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id'])) {
                                                headingCostCPValue.push({
                                                   cost_charge_id: head.cost_charge_id,
                                                   cpvalue: e.target.value
                                                })
                                             } else {
                                                (headingCostCPValue || []).forEach(hcValue => {
                                                   if(hcValue['cost_charge_id'] === head['cost_charge_id']) {
                                                      hcValue.cpvalue = e.target.value;
                                                   }
                                                })
                                             }
                                             this.setState({ headingCostCPValue });
                                          }}
                                          onBlur={(e) => {
                                             if (((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue && !(HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType))) {
                                                this.toggleAllBids(trip);
                                             }
                                          }}
                                       />
                                       {
                                          ((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue  &&
                                          <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                             onClick={() => {
                                                this.props.submitOtherCostPrice(this.state.headingCostCPValue, 'other_cost_list')
                                                this.setState({ headingCostCPValue: [] });
                                             }}
                                          >
                                             Send
                                          </span>
                                       }
                                    </span>
                                 </div>}
                              </div>}
                              {(trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) && <Fragment>
                                 <div className="fs-13 flex">
                                    <span className="label-color fs-13 fSemibold mb-5 truncate-long-text wt-60" title={head.headingChargesValue}> {head.headingChargesValue} :  </span>
                                    <span className={'fBold wt-100 ml-5 mt--3'} title={`₹${head.headingChargesCp_inr}`}>₹{head.headingChargesCp_inr && Number(head.headingChargesCp_inr).toFixed(2) || ''}</span>
                                    {currencyType && Object.keys(currencyType).length > 0 && currencyType.currency_name !== 'INR' && <span className={'fBold ml-10 wt-100 ml-5'} title={`${currencyType.currency_type !== 1 && currencyType.currency_symbol || '$'}${head[`headingChargesCp_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`]}`}>{currencyType.currency_type !== 1 && currencyType.currency_symbol || '$'}{head[`headingChargesCp_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && Number(head[`headingChargesCp_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2) || ''}</span>}
                                 </div>

                                 {
                                 (rfq.rfqDetails.biddingEnd < systemTime) &&
                                    (trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) &&
                                    <div className="mb-5 flex">
                                       <span className="label-color fs-13 mr-5 mt-3 wt-60 truncate-long-text" title={`${head.headingChargesValue} CP: ` }>{`${head.headingChargesValue} CP: ` } </span>
                                       <span className="flex header-medium-color fSemibold mr-5 wt-100">
                                          ₹ <input
                                             className={Classname("ht-20 fSemiBold border-bottom-light-2 wt-60", { 'disabled': [2, 3].includes(+head.headingChargesUnit) })}
                                             placeholder="CP"
                                             // value={this.state.headingCostCPValue[0]['cost_charge_id'] || ''}
                                             value= {((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue_inr || ''}
                                             onChange={(e) => {
                                                const { headingCostCPValue } = this.state;
                                                const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType.currency_type === 3 ? 'EUR to INR' : 'USD to INR'));
                                                if(!(headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id'])) {
                                                   headingCostCPValue.push({
                                                      cost_charge_id: head.cost_charge_id,
                                                      cpvalue_inr: e.target.value,
                                                      cpvalue: e.target.value,
                                                      [`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`]: e.target.value && conversionUSDObj && (e.target.value / (conversionUSDObj.rupee)).toFixed(5) || e.target.value
                                                   })
                                                } else {
                                                   (headingCostCPValue || []).forEach(hcValue => {
                                                      if(hcValue['cost_charge_id'] === head['cost_charge_id']) {
                                                         hcValue.cpvalue_inr = e.target.value;
                                                         hcValue.cpvalue = e.target.value;
                                                         hcValue[`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`] = e.target.value && conversionUSDObj && (e.target.value / (conversionUSDObj.rupee)).toFixed(5) || e.target.value
                                                      }
                                                   })
                                                }
                                                this.setState({ headingCostCPValue });
                                             }}
                                             onBlur={(e) => {
                                                if (((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue_inr && !(HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType))) {
                                                   this.toggleAllBids(trip);
                                                }
                                             }}
                                          />
                                          {/* {
                                             ((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {}).cpvalue  &&
                                             <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                                onClick={() => {
                                                   this.props.submitOtherCostPrice(this.state.headingCostCPValue, 'other_cost_list')
                                                   this.setState({ headingCostCPValue: [] });
                                                }}
                                             >
                                                Send
                                             </span>
                                          } */}
                                       </span>
                                       <span className="flex header-medium-color fSemibold mr-5 ml-5 wt-100">
                                          {currencyType.currency_name !== 'INR' && <>
                                          <span className="mt-3">{currencyType.currency_symbol || ''}</span><input
                                             className={Classname("ht-20 fSemiBold border-bottom-light-2 wt-60", {'disabled': +head.headingChargesUnit === 1 })}
                                             placeholder="CP"
                                             // value={this.state.headingCostCPValue[0]['cost_charge_id'] || ''}
                                             value= {((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {})[`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`] || ''}
                                             onChange={(e) => {
                                                const { headingCostCPValue } = this.state;
                                                const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType.currency_type === 3 ? 'EUR to INR' : 'USD to INR'));
                                                if(!(headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id'])) {
                                                   headingCostCPValue.push({
                                                      cost_charge_id: head.cost_charge_id,
                                                      [`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`]: e.target.value,
                                                      cpvalue: e.target.value && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5) || e.target.value,
                                                      cpvalue_inr: e.target.value && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5) || e.target.value
                                                   })
                                                } else {
                                                   (headingCostCPValue || []).forEach(hcValue => {
                                                      if(hcValue['cost_charge_id'] === head['cost_charge_id']) {
                                                         hcValue[`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`] = e.target.value;
                                                         hcValue.cpvalue_inr = e.target.value && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5) || e.target.value;
                                                         hcValue.cpvalue = e.target.value && conversionUSDObj && (e.target.value * conversionUSDObj.rupee).toFixed(5) || e.target.value;
                                                      }
                                                   })
                                                }
                                                this.setState({ headingCostCPValue });
                                             }}
                                             onBlur={(e) => {
                                                if (((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {})[`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`]  && !(HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType))) {
                                                   this.toggleAllBids(trip);
                                                }
                                             }}
                                          />
                                          </>}
                                          {
                                             ((this.state.headingCostCPValue || []).find(hcValue => hcValue['cost_charge_id'] === head['cost_charge_id']) || {})[`cpvalue_${currencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && ((HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType)) ? (trip.bids.length > 0 && ((selectedBids || []).filter((selectedBid) => selectedBid.tripId === trip.id)).length > 0) : true) &&
                                             <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                                onClick={() => {
                                                   if((HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType)) && head.headingChargesValue === ([13,14,15].includes(trip.rfqType) ? 'Service Charges' : 'Base Freight')) {
                                                      const { headingCostCPValue } = this.state;
                                                      (headingCostCPValue || []).forEach(hcValue => {
                                                         if(hcValue['cost_charge_id'] === head['cost_charge_id']) {
                                                            this.props.submitPrice(hcValue.cpvalue, trip, hcValue.cpvalue_usd, hcValue.cpvalue_secondary);
                                                         }
                                                      })
                                                   }
                                                   this.props.submitOtherCostPrice(this.state.headingCostCPValue, 'other_cost_list', trip)
                                                   this.setState({ headingCostCPValue: [] });
                                                }}
                                             >
                                                Send
                                             </span>
                                          }
                                       </span>
                                    </div>}

                                 </Fragment>}
                              </Fragment>
                           )
                           
                        }
                        return null;
                     })
                  }
                  { isAdaniWilmar() && trip.rfqType === 3 && rfq.rfqDetails.secondaryContractType === 2 && 
                  <div className="fs-12 mt-5">
                     <span className="table-text-color">Slab (MT): </span>
                     <span className="header-medium-color fSemibold"> {`${trip.fromRange} - ${trip.toRange}`} </span>
                  </div>
                  }
                  {trip.legName !== "Yard To Yard (BCN)" && <div className="fs-12 mt-5">
                     <span className="table-text-color">LPP: </span>
                     <span className="header-medium-color fSemibold"> {trip.lpp1 ? `₹ ${trip.lpp1}` : (trip.lpp && `₹ ${trip.lpp}` || '')}
                        {
                           // (Object.keys(tripLPP).length > 0 && tripLPP[trip.id]) ? <span>{tripLPP[trip.id].lpp} <br /> <span className="caption-color fSemibold fs-12">{tripLPP[trip.id].pricing_basis}</span></span> : <span>0</span>
                        }
                     </span>
                     {(trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) &&  <span className="header-medium-color fSemibold ml-5">{trip.lpp1 ? `$${trip.lppUsd}` : (trip.lpp && `$${trip.lppUsd}` || '')}</span>}
                  </div>}
                  {isVishaka() && trip.biddingDetails.businessVolumeValue &&
                     <div className="section-sub-header-color fs-12 mt-5 op-79"><b>Business Volume:</b> {trip.biddingDetails.businessVolumeValue}  {trip.biddingDetails.businessVolumeUnitName}</div>
                  }
                  {isVishaka() && trip.biddingDetails.cargoQuantity &&
                     <div className="section-sub-header-color fs-12 mt-5 op-79"><b>Cargo Weight:</b> {trip.biddingDetails.cargoQuantity} {rfq?.packing_type_name}</div>
                  }
                  {trip.average_lpp ? <div className="fs-12 mt-5">
                     <span className="table-text-color">Average LPP: {trip.average_lpp} </span>
                     <span className="header-medium-color fSemibold"></span>
                  </div> : ''}
                  {isShowLppDetail && <div>
                     <div className="fs-12 mt-5">
                       <span className="table-text-color">Lpp Date : </span>
                           {trip.lppPreviousDate && <span className="header-medium-color fSemibold"> {Moment(trip.lppPreviousDate).format('DD MMM YYYY')}</span>}
                     </div>
                      <div className="fs-12 mt-5">
                         <span className="table-text-color">Lpp Vehicle Type: </span>
                          <span className="header-medium-color fSemibold"> {trip.lppPreviousVehicleType}</span>
                     </div>
                      {isGreenPly() && <div className="fs-12 mt-5">
                         <span className="table-text-color">SSP : </span>
                        <span className="header-medium-color fSemibold"> {trip.biddingDetails.systemSuggestedPrice}</span>
                     </div>}
                     </div>
                     }
                  {displayBaseVolume && <div className="">
                     <span className="table-text-color">Base Volume:
                        <Input type="number"
                           onChange={(e) => { this.onChangeBaseVolume(trip, e) }}
                           onBlur={(e) => { this.onChange(trip, e) }}
                           name="trucksCount"
                           value={this.state.baseVolume === 0 ? trip.base_volume : this.state.baseVolume}
                           placeholder=""
                           className="col-3 inBlock fs-12 ml-5"
                        />
                     </span>
                  </div>
                  }
                  {
                     // trip && <div className="theme-color fs-14 fSemibold curP t-3 pr" onClick={(e) => this.showChangeBidding(e, trip)}>Change bid end time</div>
                  }
                  {this.renderCalendarPerTrip(trip)}
               </div>

               {user && user.isAdmin && trip && trip.bids.length === 0 &&
                  <div className={Classname("", {
                     "mr-left-30p": rfq.type === 6,
                     "mr-left-40p": rfq.type !== 6
                  })} >
                     <button class="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 curP" onClick={this.deleteTripDetails.bind(this, trip)}>{rfq.type === 6 ? 'Delete' : 'Delete Trip'}</button>
                  </div>
               }
               {this.state.showCancelPopup &&
                  <ConfirmationPopup
                     text={isTripMessage}
                     onConfirm={this.deleteTripDetailsShowPop}
                     onCancel={() => { this.setState({ showCancelPopup: false }) }}
                  />
               }
            {this.state.showCancelPopup &&
                  <ConfirmationPopup
                     text={isTripMessage}
                     onConfirm={this.deleteTripDetailsShowPop}
                     onCancel={() => { this.setState({ showCancelPopup: false }) }}
                  />
               }

               {this.state.isLoiCancelPopupShown && <CancelLOiPopUp text={'Are You Sure You Want To Cancel Loi?'} onConfirm={this.onConfirmCancelLoi} onCancel={this.hideLOICancelPopup} loiCancelRemark ={this.state.loiCancelRemark} onChangeLoiCancelRemarks={this.onChangeLoiCancelRemarks}/>}
               {/* <div className="mr-left-40p">
                    <button class="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 curP" onClick={this.deleteTripDetails.bind(this, trip)}>Delete Trip</button>
                    </div> */}

               {
                  (isRoquetteBidEnd ? bided_transporter_name : ((activeBids))).map((bid, bidIndex) => {
                     if(isRoquetteBidEnd) {
                        bid = ((sortedBidsLTC || []).find(sBid => (((sBid || {}).sum_order_text || '') === (bided_transporter_name[bidIndex].sum_order_text)))) || {}
                     }
                     const id = bid.id;
                     if(isRoquetteBidEnd && ((bid || {}).sum_order_text || '') !== (bided_transporter_name[bidIndex].sum_order_text)) {
                        return (
                           <div className='wt-250'>
                           </div>
                        )
                     }
                     let isActiveValue = dashboardActiveView;
                     let isLoiBidApprover;
                     if (bid.isLoiApproved === undefined) {
                        isLoiBidApprover = true;
                     } else {
                        isLoiBidApprover = bid.isLoiApproved;

                     }
                     if (isActiveValue !== 10 || isActiveValue !== 12) {
                        this.isPendiingAppoverBids = true;
                     }
                     if (isActiveValue === 12) {
                        this.isPendiingAppoverBids = bid.isLoiApproved;
                     }
                     if (isActiveValue === 10) {
                        this.isPendiingAppoverBids = !isLoiBidApprover;
                     }
                     if((bid.approval_matrix || []).length > 0) {
                        (((bid.approval_matrix || [])[0] || {}).levels || []).forEach((el) => {
                           el.usernames = [];
                           (rfq['approver_names'] || []).forEach(approver => {
                              if((el.emails || []).includes(approver.email)) {
                                 el.usernames.push(approver.user_name)
                              }
                           });
                           (bid.bid_approved_status || []).forEach(bidApproved => {
                              if((el.emails || []).includes(bidApproved.approved_by)) {
                                 el['loi_approved_date'] = bidApproved.loi_approved_date;
                                 if(isCoromandel()|| isVishaka()) {
                                 el['sendLoiForApproverRemarks'] = bidApproved.sent_loi_for_approver_remarks;
                                 }
                                 el['loiApproved'] = true;
                              }
                           })
                        })
                     }
                     const isBidSelected = selectedBids.find((bid) => { return bid && (bid.id === id); });
                     return (
                        <div className={Classname("flex flex-middle pl-15 curP",{
                           'wt-250': (trip.rfqType !== 5 || ![13,14,15].includes( trip.rfqType)),
                           'wt-300': (trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)),
                           // 'v-hidden'
                        })} key={(trip.id + id)} >
                           {(isRoquetteBidEnd ? (dashboardActiveView === 5 ? ((bid.isLoiSent && !bid.isAccept) ? (bid.loiAcceptValidTo <= systemTime && (user.isApprover ? (rfq.user_email === user.email) : true )) : (((bid.isLoiSent && bid.isAccept === false) || (bid.isLoiSent === false && bid.isAccept === false)) ? true : (!bid.isLoiSent && !bid.isAccept && !bid.isSentLoiApprover && !bid.isLoiApproved))) : true) : ([...CARGIL, ...BEAM,...COROMANDEL].includes(user.companyId) ? true : !(bid.isAccept === true))) && this.isPendiingAppoverBids && !isTK11 && ((CARGIL.includes(user.companyId) && (rfq.rfqDetails.biddingEnd > systemTime)) ? true : !bid.isWithDrawBid ) && (bid.cancelLoiEnableorDisable ? (bid.cancelLoiSendCount < bid.minimumCountSendToCancelLoi) : !bid.cancelLoiEnableorDisable) && !(rfq.type === 1 && ['737'].includes(rfq.companyId)) &&
                           <Checkbox type="square" 
                              onCheck={([...EMAMI, ...STAR_CEMENT].includes(user.companyId) && isEmamiCompleteSolution) ? () => {} : this.selectBid.bind(this, bid)} 
                              checked={isBidSelected}
                              className="mr-5" isBids="true"
                           />}
                           {this.isPendiingAppoverBids && <div>
                              <div className={Classname("flex-flex-middle mb-10", {
                                 'wt-250': (trip.rfqType === 5 || [13,14,15].includes( trip.rfqType))
                              })} onClick={(e) => this.setBidAndTrip(e, bid, trip)}>
                                 <div className="flex flex-middle mb-2">
                                    {
                                       hideTransportersName
                                          ?
                                          <Fragment>
                                             {
                                                trip.relayEndTime
                                                   ?
                                                   <Fragment>
                                                      {
                                                         // new Date().getTime() > new Date(trip.biddingDetails.to).getTime() &&
                                                         // new Date().getTime() > new Date(trip.relayEndTime).getTime() &&
                                                         systemTime > new Date(trip.biddingDetails.to).getTime() &&
                                                         systemTime > new Date(trip.relayEndTime).getTime() &&
                                                         <div className="fSemibold header-dark-color mr-10 fs-14">{bid.transporterName}</div>
                                                      }
                                                   </Fragment>
                                                   :
                                                   <Fragment>
                                                      {
                                                         // new Date().getTime() > new Date(trip.biddingDetails.to).getTime() &&
                                                         systemTime > new Date(rfq.rfqDetails.biddingEnd).getTime() &&
                                                         <div className="fSemibold header-dark-color mr-10 fs-14">{bid.transporterName}</div>
                                                      }
                                                   </Fragment>
                                             }
                                          </Fragment>
                                          :
                                          <>{!(isEmamiCompleteSolution || isRoquetteBidEnd) && <div className="fSemibold header-dark-color mr-10 fs-14">{bid.transporterName} </div>}</>
                                          // hideTransporter false, current: divyaprovider2
                                    }
                                    {(isApprovalMode || isEmamiCompleteSolution || isRoquetteBidEnd) && 
                                    <Status status={{ statusText: bid.orderText, colorCode: bid.colorCode, hideText: true }} hideText={true} />}
                                 </div>
                                 {[13,14,15].includes(trip.rfqType) && <>{this.getLOIStatus(bid)}</>}
                                 {bid.shippingLineName && <div className="wt-250 truncate-long-text"><span className="fBold fs-12 mt-10" title={bid.shippingLineName}><span className="label-color">{(HIKAL.includes(getUser().companyId) || [13,14,15].includes(trip.rfqType)) ? ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? 'Shipping Line: ' : 'Air Line: ') : 'Shipping Line: '}</span>{bid.shippingLineName}</span></div> || null}
                                 {bid.containerFreeDay && <div className="wt-250 truncate-long-text"><span className="fBold fs-12 mt-10" title={`${bid.containerFreeDay} ${bid.containerDaysHours && (Number(bid.containerDaysHours) === 1 ? 'Days' : 'Hours') || ''}`}><span className="label-color">{(HIKAL.includes(getUser().companyId) || [13,14,15].includes(trip.rfqType)) ? `${((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4 ) ? 'Container Shipment: ' : 'Storage Free Days: '}` : 'Container Free: '}</span>{bid.containerFreeDay} {bid.containerDaysHours && (Number(bid.containerDaysHours) === 1 ? 'Days' : 'Hours') || ''}</span></div> || null}
                                    {bid.pointOfLoading && 
                                       <div className={Classname("truncate-long-text",{
                                                         'wt-250': (trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)),
                                                         'wt-200': (trip.rfqType !== 5 || ![13,14,15].includes( trip.rfqType)),
                                                      })}>
                                          <span className="fBold fs-12 mt-10" title={bid.pointOfLoading}><span className="label-color">Point Of Loading: </span>{bid.pointOfLoading}</span>
                                       </div> || null
                                    }
                                    {bid.pointOfDestination &&
                                       <div className={Classname("truncate-long-text",{
                                          'wt-250': (trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)),
                                          'wt-200': (trip.rfqType !== 5 || ![13,14,15].includes( trip.rfqType)),
                                       })}>
                                          <span className="fBold fs-12 mt-10" title={bid.pointOfDestination}><span className="label-color">Point Of Destination: </span>{bid.pointOfDestination}</span>
                                       </div> || null
                                    }
                                    <div className="fs-14 fSemibold mb-2">
                                    
                                    <span className={Classname({
                                       "header-dark-color": !bid.isCounter,
                                       "challenge-color": bid.isCounter
												})}>
                                       <span className="label-color fs-13">
                                          {isRoquette ? 'Base Price' : 'Total Price'} :
                                       </span> 
                                    <span title={(trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) ? `₹${bid.price && Number(bid.price.toFixed(2))}` : `₹${bid.price}`}>{(trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) ? `₹${bid.price && Number(bid.price.toFixed(2))}` : `₹ ${bid.price && bid.price.toFixed(2)}`}</span> 
                                    {((trip.rfqType === 5 && HIKAL.includes(user.companyId)) || [13,14,15].includes( trip.rfqType)) && <a data-tip data-for={`${trip.id}_${bid.transporterId}_${bid.id}`}><span className="tooltip-icon fBold">c</span></a>}
                                    { (trip.rfqType === 5 || [13,14,15].includes( trip.rfqType)) && trip.priceInBaseCurrency !== 'INR' && <span className="ml-5" title={`${trip.priceInBaseCurrencySymbol || ''}${bid[`price${trip.priceInBaseCurrency === "USD" ? 'USD' : 'Secondary'}`] && Number(bid[`price${trip.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary'}`]).toFixed(2)}`}>{trip.priceInBaseCurrencySymbol || ''}{bid[`price${trip.priceInBaseCurrency === "USD" ? 'USD' : 'Secondary'}`]&& Number(bid[`price${trip.priceInBaseCurrency === "USD" ? 'USD' : 'Secondary'}`]).toFixed(2)} </span> || ''}</span>
                                    <span className="caption-color fSemibold fs-12 ml-5">{bid.pricingBasis} </span>
                                    <span className="header-dark-color">{bid.transporterVol ? bid.transporterVol + " MT" : ""}</span>
                                    {bid.bid_price_volume_mt && <span><span className="label-color fs-13">Total Price (MT): </span>{`₹${bid.bid_price_volume_mt && Number(bid.bid_price_volume_mt.toFixed(2))}`}</span>}
                                    {((trip.rfqType === 5 && HIKAL.includes(user.companyId)) || [13,14,15].includes(trip.rfqType)) && <ReactTooltip id={`${trip.id}_${bid.transporterId}_${bid.id}`} type="dark" effect="solid" place={[13,14,15].includes( trip.rfqType) ? "bottom" : "top"}>
                                       <CostHeadCalculation data={bid.multiModeHeadingCharges || []} />
                                    </ReactTooltip>}
                                    {bid.isCounter && !bid.cpState && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">Counter</span>}
                                    {bid.cpState && (bid.cpState === CHALLENGE_PRICE_ACCEPTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">CP Accepted</span>}
                                    {bid.cpState && (bid.cpState === CHALLENGE_PRICE_REJECTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">CP Rejected</span>}
                                    {bid.cp_accept_valid_from && bid.cp_accept_valid_to &&
                                       bid.cp_accept_valid_to < systemTime && ![CHALLENGE_PRICE_REJECTED, CHALLENGE_PRICE_ACCEPTED].includes(bid.cpState) &&
                                       <div className='pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-error fSemibold fs-12 wt-70'>CP Ignored</div>
                                    }
                                    {bid.isWithDrawBid && !bid.isAccessBidWithdrawn && <Fragment><br /><span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-withdraw-bid fSemibold fs-12">Bid Withdrawn</span></Fragment>}
                                    {(bid.isWithDrawBid && bid.isAccessBidWithdrawn) &&<Fragment><br/><span className="header-dark-color bg-success pr-2 pl-2 pt-2 pb-2 br-5">Bid Revoked </span></Fragment>}
                                    {
                                       bid.dph_percentage &&
                                       <div className="fs-12 mt-5 flex">
                                          {bid.dph_uom == 2 ? 
                                          <>PR Amount: <span className='theme-color fs-14 ml-5'>₹{bid.dph_amount}</span></>
                                          : <>{`${isCargil ? 'PR' : 'DPH'} Percentage`}: <span className='theme-color fs-14 ml-5'>{bid.dph_percentage}%</span></>}
                                          {bid.dph_price_increase ? <UpArrow className="ht-15 wt-20"/> : <DownArrow className="ht-15 wt-20"/>}</div>
                                    }
                                    {
                                       bid.current_price && 
                                       <div className="fs-12 mt-5 flex">Current Price:<span className='theme-color fs-14 fBold ml-5 mt--3'>₹{bid.current_price && bid.current_price.toFixed(2)}</span><span className="caption-color fSemibold fs-12 ml-5">{bid.pricingBasis} </span>
                                       <span className="header-dark-color">{bid.transporterVol ? bid.transporterVol + " MT" : ""}</span></div>
                                    }
                                    {
                                       bid.revised_price && 
                                       <div className="fs-12 mt-5 flex">Revised Price:<span className='theme-color fs-14 fBold ml-5 mt--3'>₹{bid.revised_price && bid.revised_price.toFixed(2)}</span><span className="caption-color fSemibold fs-12 ml-5">{bid.pricingBasis} </span>
                                       <span className="header-dark-color">{bid.transporterVol ? bid.transporterVol + " MT" : ""}</span></div>
                                    }
                                    {
                                       bid.dph_from_date && bid.dph_to_date && 
                                       <div className="fs-12 mt-5 mb-5">{`${isCargil ? 'PR' : 'DPH'} Validity`}: {CARGIL.includes(user.companyId) && 
                                          <span className='mb-5 error-color fs-13 curP fBold curP' onClick={(e) => {
                                             e.stopPropagation();
                                             this.props.showPRDetails(bid.transporterId, bid.tripId);
                                          }}>View PR Details</span>
                                       }<br/><div className='theme-color fs-13'>{bid.dph_from_date && Moment(bid.dph_from_date).format('DD MMM YYYY')} - {bid.dph_to_date && Moment(bid.dph_to_date).format('DD MMM YYYY')}</div></div>
                                    }
                                    {
                                       bid.dph_remarks && 
                                       <div className="fs-12 mt-5 mb-5">{`${isCargil ? 'PR' : 'DPH'} Remarks`}: <br/><div className='theme-color fs-13'>{bid.dph_remarks || ''}</div></div>
                                    }
                                    {
                                       bid.pr_amount &&
                                       <div className="fs-12 mt-5 flex">{`${isCargil ? 'PR' : 'DPH'} Amount`}: <span className='theme-color fs-14 ml-5'>₹{bid.pr_amount}</span>{bid.pr_amount_increase ? <UpArrow className="ht-15 wt-20"/> : <DownArrow className="ht-15 wt-20"/>}</div>
                                    }
                                    {
                                       bid.pr_current_amount && 
                                       <div className="fs-12 mt-5 flex">Current Price:<span className='theme-color fs-14 fBold ml-5 mt--3'>₹{bid.pr_current_amount && bid.pr_current_amount.toFixed(2)}</span><span className="caption-color fSemibold fs-12 ml-5">{bid.pricingBasis} </span>
                                       <span className="header-dark-color">{bid.transporterVol ? bid.transporterVol + " MT" : ""}</span></div>
                                    }
                                    {
                                       bid.pr_revised_amount && 
                                       <div className="fs-12 mt-5 flex">Revised Price:<span className='theme-color fs-14 fBold ml-5 mt--3'>₹{bid.pr_revised_amount && bid.pr_revised_amount.toFixed(2)}</span><span className="caption-color fSemibold fs-12 ml-5">{bid.pricingBasis} </span>
                                       <span className="header-dark-color">{bid.transporterVol ? bid.transporterVol + " MT" : ""}</span></div>
                                    }
                                    {
                                       bid.pr_from_date && bid.pr_to_date && 
                                       <div className="fs-12 mt-5 mb-5">{`${isCargil ? 'PR' : 'DPH'} Validity`}: <br/><div className='theme-color fs-13'>{bid.pr_from_date && Moment(bid.pr_from_date).format('DD MMM YYYY')} - {bid.pr_to_date && Moment(bid.pr_to_date).format('DD MMM YYYY')}</div></div>
                                    }
                                    {
                                       bid.pr_remarks && 
                                       <div className="fs-12 mt-5 mb-5">{`${isCargil ? 'PR' : 'DPH'} Remarks`}: <br/><div className='theme-color fs-13'>{bid.pr_remarks || ''}</div></div>
                                    }
                                    {(AWL_AND_CPL.includes(user.companyId) || DEEPAK_PHENOLICS_SAP.includes(user.companyId) || isCoromandel()) && (isAdaniWilmar() ? trip.rfqType !== 6 : true) &&
                                        bid.tk11_msg && bid.tk11_status &&  bid.tk11_status  === 2 && <span className="header-dark-color bg-accept pr-2 pl-2 pt-2 pb-2 br-5">Tk11 {bid.tk11_msg }</span>
                                    }
                                    {
                                       (AWL_AND_CPL.includes(user.companyId) || DEEPAK_PHENOLICS_SAP.includes(user.companyId) || isCoromandel()) && (isAdaniWilmar() ? trip.rfqType !== 6 : true) &&
                                       bid.tk11_msg &&  bid.tk11_status  && TK11STATUS.includes(bid.tk11_status) && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">Tk11 {bid.tk11_msg }</span>
                                    }
                                    {rfq.reactivate_tk11 && bid.tk11_msg &&  bid.tk11_status && bid.tk11_status  === 2 && <div className="fs-14 theme-color curP pt-2 pb-2" onClick={(e) => this.reactivateTk11(e, bid)}>Reactivate Tk11</div>}
                                 </div>
                                 {(bid.isSentDPHApprover || bid.isDPHApproved) && 
                                 <div>
                                       {bid.isSentDPHApprover && <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5 fs-12">{`DPH Sent for Approver ${(((rfq['dph_approver_names'] || []).find(approver => approver.email === (bid.bid_dph_approver_emails || []).join('')) || {}).user_name || '') || ''}`}</span>}
                                       {bid.isDPHApproved && <span className="header-dark-color bg-approved pr-2 pl-2 pt-2 pb-2 br-5 fs-12">{`DPH Approved`}</span>}
                                       <a data-tip data-for={`scrollDPHApprovalContent-${index}`} data-iscapture='true'> <span className="approval-tooltip tooltip-icon fBold">i</span> </a>
                                       <ReactTooltip
                                          id={`scrollDPHApprovalContent-${index}`}
                                          type="light"
                                          effect="solid"
                                          place="right"
                                          className="tooltip-trip-shadow"
                                          delayHide={100}
                                       >
                                          <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                                             <section className="flex mt-25 flex-column">
                                                <ApprovalMatrixDetails 
                                                lineItem={((bid.dph_approval_matrix || [])[0] || {}).levels || []} 
                                                approvalUser={bid.dph_approval_matrix && ((((((bid.dph_approval_matrix || [])[0] || {}).levels || [])[bid.bid_dph_approved_emails.length] || {}).usernames || []).join(', ') || '') || ''} 
                                                bid={bid} 
                                                isRoquette={isRoquette} 
                                                rfq={rfq} 
                                                isDPH={true}
                                                />
                                             </section>
                                          </div>
                                       </ReactTooltip> 
                                 </div>}
                                 {bid.bid_remarks && <div className="header-dark-color fs-14 fSemibold mb-2 break-all">
                                    <span className="label-color fs-13">Remarks: </span><span>{bid.bid_remarks}</span>
                                 </div>}
                                 {!bid.price && <div className="mr-left-40p" >
                                    <button class="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 curP" onClick={this.deleteTripDetails.bind(this, trip)}>Delete Trip</button>
                                 </div>}
                                 {bid.tripCost && 
                                    <div className={(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType))?"theme-color fs-13":"header-dark-color fs-13"}>
                                       <span className={(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType))?"theme-color fs-13":"label-color fs-13"}>Base Cost: </span>
                                       <span>₹{bid.tripCost && Number(bid.tripCost).toFixed(2)}</span>
                                       {((trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) && trip.priceInBaseCurrency !== 'INR') ? <span className="theme-color fs-13 mt-10 ml-20">{tripCurrencyType.currency_symbol || ''}{bid[`tripCost${tripCurrencyType.currency_name === 'USD' ? 'Usd' : 'Secondary'}`] && Number(bid[`tripCost${tripCurrencyType.currency_name === 'USD' ? 'Usd' : 'Secondary'}`]).toFixed(2)}</span> : null }
                                    </div> || ''}
                                 {isAdaniCompleteSolution && bid.sales_volume_price && 
                                 <div className="header-dark-color fs-14 fSemibold mb-2 break-all">
                                    <span className="label-color fs-13">Sales Price: </span><span>₹{bid.sales_volume_price}</span>
                                 </div>
                                 }

                                 <div className="flex-flex-middle mb-2">
                                    <div className="fs-12 fSemibold">
                                       

                                       {bid.isLoiSent && bid.isAccept !== false && bid.isAccept !== true && !isApproveMessage &&
                                          <span className={Classname("header-dark-color pr-2 pl-2 pt-2 pb-2 br-5", {
                                             // "bg-counter": !(bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= new Date().getTime()),
                                             // "bg-error": (bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= new Date().getTime())
                                             "bg-counter": !(bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= systemTime),
                                             "bg-error": (bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= systemTime)
                                          })}>
                                             {
                                                // bid.loiAcceptValidTo <= new Date().getTime()
                                                bid.loiAcceptValidTo <= systemTime
                                                   ?
                                                   <Fragment>{`${rfq.type === 8 ? 'PO' : 'LOI'} Ignored`}</Fragment>

                                                   :
                                                   <Fragment>{`${rfq.type === 8 ? 'PO' : 'LOI'} Sent`}</Fragment>
                                             }
                                             {(bid.seekerRemarks && bid.seekerRemarks.length > 0) &&
                                                <Fragment>
                                                   <a data-tip='tooltip' data-for={`seeker-remark-tooltip-${id}`}> <span className="tooltip-icon fBold">i</span> </a>
                                                   <ReactTooltip globalEventOff='click' id={`seeker-remark-tooltip-${id}`} type="dark" effect="solid">
                                                      <span> {bid.seekerRemarks} </span><br />
                                                   </ReactTooltip>
                                                </Fragment>
                                             }
                                             {(bid.seekerInstructions && bid.seekerInstructions.length > 0) &&
                                                <Fragment>
                                                   <a data-tip='tooltip' data-for={`seeker-instruction-tooltip-${id}`}> <span className="tooltip-icon fBold">R</span> </a>
                                                   <ReactTooltip globalEventOff='click' id={`seeker-instruction-tooltip-${id}`} type="dark" effect="solid">
                                                      <span> {bid.seekerInstructions} </span><br />
                                                   </ReactTooltip>
                                                </Fragment>
                                             }
                                          </span>
                                       }

                                       {![13,14,15].includes(trip.rfqType) && <>{this.getLOIStatus(bid, trip.rfqType)}</>}
                                       {(bid.loiRejectionReason && bid.loiRejectionReason.length > 0) && !bid.isLoiSent && bid.isAccept === false && 
                                             <Fragment>
                                             <a data-tip='tooltip' data-for={`seeker-instruction-tooltip-${id}`}> <span className="tooltip-icon fBold">L</span> </a>
                                             <ReactTooltip globalEventOff='click' id={`seeker-instruction-tooltip-${id}`} type="dark" effect="solid">
                                                <span> {bid.loiRejectionReason} </span><br />
                                             </ReactTooltip>
                                               </Fragment>
                                        }
                                        {
                                          <div>{bid.loi_rejected_approver &&
                                             <>
                                                <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">{`LOI Rejected By Approver`}</span>
                                                {/* <a data-tip data-for={`scrollRApprovalContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">R</span> </a>
                                                   <ReactTooltip globalEventOff='click' id={`scrollRApprovalContent-${index}`} type="dark" effect="solid">
                                                      <span> {bid.approver_loi_reject_remarks} </span><br />
                                                   </ReactTooltip> */}
                                                <a data-tip data-for={`scrollRApprovalContent-${id}`} data-iscapture='true'> <span className="approval-tooltip tooltip-icon fBold">i</span> </a>
                                                   <ReactTooltip
                                                      id={`scrollRApprovalContent-${id}`}
                                                      type="light"
                                                      effect="solid"
                                                      place="bottom"
                                                      className="tooltip-trip-shadow"
                                                      delayHide={100}
                                                   >
                                                      <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                                                         <section className="flex mt-25 flex-column">
                                                            <ApprovalRejectedStatus  data={bid.bid_reject_status} rfq={rfq}/>
                                                         </section>
                                                      </div>
                                                   </ReactTooltip> 
                                             </>}</div>
                                        }
                                       <div>{bid.isLoiApproved && 
                                       <>
                                          <span className="header-dark-color bg-approved pr-2 pl-2 pt-2 pb-2 br-5">{`${rfq.type === 8 ? 'PO' : 'LOI'} Approved`}</span>
                                          <a data-tip data-for={`scrollAApprovalContent-${index}-${bidIndex}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                                             <ReactTooltip
                                                id={`scrollAApprovalContent-${index}-${bidIndex}`}
                                                type="light"
                                                effect="solid"
                                                place="right"
                                                className="tooltip-trip-shadow"
                                                delayHide={100}
                                             >
                                             <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                                                <section className="flex mt-25 flex-column">
                                                   <ApprovalMatrixDetails 
                                                   lineItem={((bid.approval_matrix || [])[0] || {}).levels || []} 
                                                   bid={bid}
                                                   approvalUser={bid.approval_matrix && ((((((bid.approval_matrix || [])[0] || {}).levels || [])[bid.bid_approved_emails.length] || {}).usernames || []).join(', ') || '') || ''}
                                                   />
                                                </section>
                                             </div>
                                          </ReactTooltip>
                                       </>}</div>
                                       {bid.isLoiSent && bid.isAccept !== false && bid.isAccept !== true && !isApproveMessage && bid.isLoiApproved && <div className={'bg-counter pr-2 pl-2 pt-2 pb-2 br-5'}>{'Pending From Transporter'}</div>}
                                    </div>
                                    {CARGIL.includes(rfq.companyId) && bid.additional_cost && <div className='fs-13'><span>Other Charges Added</span><AcceptIcon className="wt-12 ht-12 curP z-100 ml-5 mt-5"/></div>}
                                    {isTK11 && bid.tkResponse &&
                                       <div className="fs-12 fSemibold mt-5"><span className="caption-color mr-5">Success/Error :</span>
                                          <span className="success-color fs-14">{(bid.tkResponse || []).filter(res => res.resCode === 'S').length}</span> <span className="fs-14"> / </span><span className='error-color fs-14'>{(bid.tkResponse || []).filter(res => res.resCode === 'E').length}</span>
                                       </div>
                                    }
                                    {isTK11 &&
                                    //  !this.hasTk11Failed(bid) &&
                                       (bid.tkResponse || []).map((response) => {
                                          return (
                                             <Fragment>{(response.resCode === 'S') && <div className="fSemibold success-color mr-10 fs-14 curP mt-5">{response.sapContractNumber} ({response.planningPoint})<br /></div>}</Fragment>
                                          )
                                       })
                                    }
                                    {isTK11 && this.hasTk11Failed(bid) &&
                                       <div className="fSemibold error-color mr-10 fs-14 curP" onClick={(e) => { 
                                          e.preventDefault(); 
                                          const tk11SelctedPlant = [];
                                          (bid.tkResponse || []).forEach(tkRes => {
                                                if(tkRes.resCode === 'E') {
                                                   tk11SelctedPlant.push(tkRes.planningPoint)
                                                }
                                          })
                                         this.setState({ isPopupOpen: true , tk11SelctedPlant }) }
                                       }>Resend</div>
                                    }
												{!isTK11 && bid.challengePrice && !(bid.cpState && (bid.cpState === CHALLENGE_PRICE_ACCEPTED)) && bid.counterStatus !== COUNTER_ACCEPT && !(HIKAL.includes(user.companyId) || [13,14,15].includes(trip.rfqType)) && <div className="fSemibold success-color mr-10 fs-14"> ₹{(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) ? bid.challengePriceINR : bid.challengePrice} {trip.rfqType === 5 && tripCurrencyType.currency_name !== 'INR' && <span className="ml-5">{tripCurrencyType.currency_symbol || ''}{bid[`challengePrice${tripCurrencyType.currency_name === 'USD' ? 'USD' : 'Secondary'}`]}</span>}<span className="fs-10 caption-color">T Challenge Price </span></div>}
                                    {isVishaka() && 
                                       bid.cp_accept_valid_from && bid.cp_accept_valid_to && bid.cpState !== CHALLENGE_PRICE_ACCEPTED &&
                                       (bid.cp_accept_valid_to >= systemTime || (bid.cp_accept_valid_to < systemTime)) &&
                                       <div className='wt-120'>
                                          <Timer from={bid.cp_accept_valid_from} to={bid.cp_accept_valid_to} currentTime={systemTime} />
                                       </div>
                                    }
                                    {rfq.cancel_cp && bid.challengePrice && (bid.cpState !== CHALLENGE_PRICE_CANCELLED) && <button className="fs-12 curP loi-cancelled-color fBold" onClick={(e) => this.onOpenCancelCPPopUp(e, bid)}>Cancel CP</button>}
                                    {bid.cpState && bid.cpState === CHALLENGE_PRICE_CANCELLED && <span className="header-dark-color bg-loi-cancelled pr-2 pl-2 pt-2 pb-2 br-5 fs-12">CP Cancelled</span>}
                                    {!isTK11 && bid.counterPrice && (bid.counterStatus === undefined || bid.counterStatus === COUNTER_REJECT || bid.counterStatus === COUNTER_RESENT) && rfq.challengePriceWithCounter !== null && parseInt(rfq.challengePriceWithCounter) !== 0 && bid.cpState && (bid.cpState !== CHALLENGE_PRICE_ACCEPTED) &&
                                       <div className="fSemibold success-color mr-10 fs-14" style={{ paddingTop: '10px' }}>
                                          ₹ {bid.counterPrice}<span className="fs-10 caption-color"> Counter </span>
                                          {bid.counterPrice && (bid.counterStatus === undefined || bid.counterStatus === COUNTER_RESENT) && bid.cpState && (bid.cpState !== CHALLENGE_PRICE_ACCEPTED) && rfq.challengePriceWithCounter !== null && parseInt(rfq.challengePriceWithCounter) !== 0 &&
                                             <React.Fragment>
                                                <AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={(e) => this.handleCounterPrice(e, 'accept', bid)} />
                                                <RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={(e) => this.handleCounterPrice(e, 'reject', bid)} />
                                             </React.Fragment>
                                          }
                                       </div>
                                    }

                                    <div>{bid.counterPrice && bid.counterStatus === COUNTER_ACCEPT && bid.cpState && (bid.cpState !== CHALLENGE_PRICE_ACCEPTED) && <span className="header-dark-color bg-accept fs-12 pr-2 pl-2 pt-2 pb-2 br-5">Counter Accepted</span>}</div>
                                    <div>{bid.counterPrice && bid.counterStatus === COUNTER_REJECT && bid.cpState && (bid.cpState !== CHALLENGE_PRICE_ACCEPTED) && <span className="header-dark-color bg-reject fs-12 pr-2 pl-2 pt-2 pb-2 br-5">Counter Rejected</span>}</div>
                                       {bid.baseOrderText && 
                                       <div className="header-dark-color fs-13">
                                          <span className="orange-color fs-13">Base Order Text: </span>
                                          {(trip.rfqType === 3) ? <span className={" orange-color fs-13 mt-10 ml-5"} >{bid.baseOrderText}</span> : null }
                                       </div>}
                                    {
                                       (trip.slabs || []).map((head) => {
                                          const bidCostObj = (bid.secondarySlabs || []).filter(obj => obj.cost_charge_id === head.cost_charge_id);
                                          const bidCost = bidCostObj.length > 0 ? bidCostObj[0] : head;
                                          // if (head.cost_charges_description) {
                                             return (
                                                <div className="mt-5">
																	<span className="header-medium-color fSemibold fs-13 mb-5"> {bidCost.cost_charges_description} ({this.getSlabValue(bidCost.from_range,bidCost.to_range)}) : <span className={Classname('fBold',{
                                       "header-dark-color": !bidCost.is_counter,
                                       "challenge-color": bidCost.is_counter
                                    })}>₹{bidCost.cost_charges_qbr}</span></span>
                                                   {bidCost.cp_variable_state && (bidCost.cp_variable_state === CHALLENGE_PRICE_ACCEPTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">CP Accepted</span>}
                                                   {bidCost.cp_variable_state && (bidCost.cp_variable_state === CHALLENGE_PRICE_REJECTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">CP Rejected</span>}
                                                   {bidCost.variable_challenge_price && bidCost.cp_variable_state &&(bidCost.cp_variable_state !== CHALLENGE_PRICE_ACCEPTED) && 
                                                  <div className="fSemibold success-color mr-10 fs-14">₹ {trip.rfqType === 5 ? bidCost.other_cost_challenge_price_inr : bidCost.other_challenge_price}{(trip.rfqType === 5 && bidCurrencyType.currency_name !== 'INR') && <span className="ml-5">{bidCurrencyType.currency_type !== 1 && bidCurrencyType.currency_symbol || '$'}{bidCost[`other_cost_challenge_price_${bidCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]}</span>}<span className="fs-10 caption-color"> Challenge Price </span></div>
                                                   }
                                                </div>
                                             )
                                          // }
                                          // return null;
                                       })
                                    }
                                    {(trip.rfqType === 3 && isAdaniWilmar() && bid.extraCostPerKmPrice && (rfq.rfqDetails || {}).secondaryContractType === 1) &&
                                       <div className="mt-5">
                                          <span className="header-medium-color fSemibold fs-13 mb-5">Extra cost/km : 
                                          <span className={Classname('fBold',{
                                             "header-dark-color": !bid.is_counter,
                                             "challenge-color": bid.is_counter
                                          })}>₹{bid.extraCostPerKmPrice}</span></span>
                                          {bid.extra_cost_cp_state && (bid.extra_cost_cp_state === CHALLENGE_PRICE_ACCEPTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">CP Accepted</span>}
                                          {bid.extra_cost_cp_state && (bid.extra_cost_cp_state === CHALLENGE_PRICE_REJECTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">CP Rejected</span>}
                                          {bid.extra_cost_per_km_cp && bid.extra_cost_cp_state &&(bid.extra_cost_cp_state !== CHALLENGE_PRICE_ACCEPTED) && 
                                          <div className="fSemibold success-color mr-10 fs-14">₹ {bid.extra_cost_per_km_cp}<span className="fs-10 caption-color"> Challenge Price </span></div>
                                          }
                                       </div>
                                    }
                                    {bid.slabCost && 
                                       <div className="header-dark-color fs-13">
                                          <span className="label-color fs-13">Slab Cost: </span>
                                          {(trip.rfqType === 3) ? <span className="header-dark-color fs-13 mt-10 ml-20">₹{bid.slabCost>0 && Number(bid.slabCost).toFixed(2)}</span> : null }
                                       </div> || null}
                                       {bid.slabOrderText && 
                                       <div className="header-dark-color fs-13">
                                          <span className="theme-color fs-13">Slab Order Text: </span>
                                          {(trip.rfqType === 3) ? <span className={" theme-color fs-13 mt-10 ml-5"} >{bid.slabOrderText}</span> : null }
                                       </div>}
                                    {
                                       (trip.multiModeHeadingCharges || []).map((head) => {
                                          
                                          const bidCostObj = (bid.multiModeHeadingCharges || []).filter(obj => (trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) ? (obj.cost_charge_id === head.cost_charge_id) : (obj.headingChargesValue === head.headingChargesValue));
                                          const bidCost = bidCostObj.length > 0 ? bidCostObj[0] : head;
                                          const bidCurrencyType = (currencyTypes || []).find(el => el.currency_type == bidCost.headingChargesUnit) || {};
                                          if (head.headingChargesValue) {
                                             return (
                                                <div className="mt-5">
                                                   <div className="header-medium-color fSemibold fs-13 flex"> 
                                                   <span className="truncate-long-text wt-60 label-color" title={`${bidCost.headingChargesValue} :`}>{bidCost.headingChargesValue} :</span> 
                                                   <span className={Classname('fBold wt-200 flex', {
                                                      "header-dark-color": !bidCost.is_counter,
                                                      "challenge-color": bidCost.is_counter
																	})}> 
                                                      <span className="mt--3" title={(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) ? `₹${bidCost.headingChargesCp_inr && Number(bidCost.headingChargesCp_inr).toFixed(2)}`: `₹${bidCost.headingChargesBudget}`}>{(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) ? `₹${bidCost.headingChargesCp_inr && Number(bidCost.headingChargesCp_inr).toFixed(2)}`: `₹${bidCost.headingChargesBudget}`}</span>
                                                      {(trip.rfqType === 5 || [13,14,15].includes(trip.rfqType)) && bidCurrencyType.currency_type !== 1 && <span className="ml-10 fBold wt" title={bidCost[`headingChargesCp_${bidCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && `${bidCurrencyType.currency_type !== 1 && bidCurrencyType.currency_symbol || '$'}${Number(bidCost[`headingChargesCp_${bidCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2)}`}>{bidCost[`headingChargesCp_${bidCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`] && `${bidCurrencyType.currency_type !== 1 && bidCurrencyType.currency_symbol || '$'}${Number(bidCost[`headingChargesCp_${bidCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]).toFixed(2)}`}</span>}
                                                   </span>
                                                   </div>
                                                   {bidCost.cp_other_state && (bidCost.cp_other_state === CHALLENGE_PRICE_ACCEPTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12 tCenter">CP Accepted</span>}
                                                   {bidCost.cp_other_state && (bidCost.cp_other_state === CHALLENGE_PRICE_REJECTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12 tCenter">CP Rejected</span>}
                                                   {bidCost.other_challenge_price && bidCost.cp_other_state && (bidCost.cp_other_state !== CHALLENGE_PRICE_ACCEPTED) && 
                                                   <div className="fSemibold success-color mr-10 fs-14">₹ {trip.rfqType === 5 ? bidCost.other_cost_challenge_price_inr : bidCost.other_challenge_price}{trip.rfqType === 5 && <span className="ml-5">{bidCurrencyType.currency_type !== 1 && bidCurrencyType.currency_symbol || '$'}{bidCost[`other_cost_challenge_price_${bidCurrencyType.currency_type === 3 ? 'secondary' : 'usd'}`]}</span>}<span className="fs-10 caption-color"> Challenge Price </span></div>
                                                   }
                                                </div>
                                             )
                                          }
                                          return null;
                                       })
                                    }
                                    
												{!bid.tat.includes('undefined') && rfq.type !== 8 && <Fragment><span className="caption-color mr-5 fs-12">TAT </span>
                                       <span className="header-dark-color mr-10 fs-12">{bid.tat && <Fragment>{bid.tat}</Fragment>}</span> </Fragment>}
                                       {(bid.transporter_vehicle || []).length > 0 && <div className='fs-12'>
                                           <table border={1} cellSpacing={0} cellPadding={1}>
                                             <tr className='caption-color mr-5 fs-12'>
                                                <th>Vehicle Type</th>
                                                <th>No. of Vehicle</th>
                                                <th>Price / Vehicle</th>
                                                <th>Total Price</th>
                                             </tr>
                                             {(bid.transporter_vehicle || []).map((trans, tIndex) => {
                                             return (<tr key={tIndex}>
                                                         <td className='tCenter'>
                                                            <div>{trans.name}</div>
                                                            {trans.vehicle_size && <div className='mt-5`'>{`Vehicle Size: ${trans.vehicle_size}`}</div>}
                                                         </td>
                                                         <td className='tCenter'>{trans.number_of_vehicle}</td>
                                                         <td className='tCenter'>{trans.price_per_vehicle}</td>
                                                         <td className='tCenter'>{trans.price}</td>
                                                      </tr>)})}
                                          </table>
                                       </div> || ''}

                                       {/* {!!(bid.transporter_vehicle[0] || {}).number_of_vehicle && <Fragment>
                                       <div>
                                          <span className="caption-color mr-5 fs-12">Number of vehicle : </span>
                                          <span className="header-dark-color mr-10 fs-12">
                                             {(bid.transporter_vehicle[0] || {}).number_of_vehicle}
                                          </span>
                                       </div>
                                       </Fragment>}
                                       {!!(bid.transporter_vehicle[0] || {}).price_per_vehicle && <Fragment>
                                       <div>
                                          <span className="caption-color mr-5 fs-12">Price Per Vehicle : </span>
                                          <span className="header-dark-color mr-10 fs-12">
                                             {(bid.transporter_vehicle[0] || {}).price_per_vehicle}
                                          </span>
                                       </div>
                                       </Fragment>

                                       }

                                       {!!(bid.transporter_vehicle[0] || {}).name && <Fragment>
                                       <div>
                                          <span className="caption-color mr-5 fs-12">Vehicle type : </span>
                                          <span className="header-dark-color mr-10 fs-12">
                                             {(bid.transporter_vehicle[0] || {}).name}
                                          </span>
                                       </div>
                                       </Fragment>}

                                       {!!(bid.transporter_vehicle[0] || {}).vehicle_size && <Fragment>
                                       <div>
                                          <span className="caption-color mr-5 fs-12">Vehicle size : </span>
                                          <span className="header-dark-color mr-10 fs-12">
                                             {(bid.transporter_vehicle[0] || {}).vehicle_size}
                                          </span>
                                       </div>
                                       </Fragment>} */}
                                       
                                       {bid.bidPriceReduction && <div><span className="caption-color mr-5 fs-12">Reduction </span>
                                       <span className="header-dark-color mr-10 fs-12">{bid.bidPriceReduction && <Fragment>{bid.bidPriceReduction}%</Fragment>}</span> </div> || ''}
                                       {(isCoromandel() || isVishaka()) && <div><span className="caption-color mr-5 fs-12">Seeker Remarks</span>
                                       <span className="header-dark-color mr-10 fs-12"><Fragment>{bid?.seekerInstructions ? bid?.seekerInstructions : bid?.seekerSentLoiApproverRemarks}</Fragment></span> </div> || ''}
                                       {bid.bidReductionDiff && <div><span className="caption-color mr-5 fs-12">Reduction diff</span>
                                       <span className="header-dark-color mr-10 fs-12"><Fragment>{'₹'} {bid.bidReductionDiff}</Fragment></span> </div> || ''}
                                       {/* {bid.isSentLoiApprover && !isApproveOfLoi && <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5 fs-12">{`${rfq.type === 8 ? 'PO' : 'LOI'} Sent for Approver ${bid.approval_matrix && ((((((bid.approval_matrix || [])[0] || {}).levels || [])[bid.bid_approved_emails.length] || {}).usernames || []).join(', ') || '') || ''}`}</span>
                                       } */}
                                       {(bid.ipAddress) ? <div><span className="caption-color mr-5 fs-12">IP Address </span>
                                       <span className="header-dark-color mr-10 fs-12" style={{backgroundColor: bid.ipColorCode}}><Fragment>{bid.ipAddress}</Fragment></span> </div>:""}
                                       {(bid.cp_error_price) ? 
                                       <div>
                                          <span className="caption-color mr-5 fs-12">CP Error:  </span>
                                          <span className="header-dark-color fs-12 error-color fBold"><Fragment>{bid.cp_error_price}</Fragment></span>
                                          {bid.cp_error_status && <span className="header-dark-color mr-10 fs-12 error-color fBold"><Fragment>{` (${bid.cp_error_status})`}</Fragment></span>} 
                                       </div>:""}
                                       
                                       {bid.isSentLoiApprover && !isApproveOfLoi && <div>
                                       <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5 fs-12">{`${rfq.type === 8 ? 'PO' : 'LOI'} Sent for Approver 
                                          ${isRoquette || isDesmet() 
                                          ? (((rfq['approver_names'] || []).find(approver => approver.email === (bid.bid_approver_emails || []).join('')) || {}).user_name || '') 
                                          : bid.approval_matrix && ((((((bid.approval_matrix || [])[0] || {}).levels || [])[bid.bid_approved_emails.length] || {}).usernames || []).join(', ') || '') || ''}`}</span>
                                       <a data-tip data-for={`scrollApprovalContent-${index}`} data-iscapture='true'> <span className="approval-tooltip tooltip-icon fBold">i</span> </a>
                                       <ReactTooltip
                                          id={`scrollApprovalContent-${index}`}
                                          type="light"
                                          effect="solid"
                                          place="right"
                                          className="tooltip-trip-shadow"
                                          delayHide={100}
                                       >
                                          <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                                             <section className="flex mt-25 flex-column">
                                                <ApprovalMatrixDetails 
                                                lineItem={((bid.approval_matrix || [])[0] || {}).levels || []} 
                                                approvalUser={bid.approval_matrix && ((((((bid.approval_matrix || [])[0] || {}).levels || [])[bid.bid_approved_emails.length] || {}).usernames || []).join(', ') || '') || ''} 
                                                bid={bid} 
                                                isRoquette={isRoquette} 
                                                rfq={rfq}
                                                />
                                             </section>
                                          </div>
                                       </ReactTooltip> </div>}
                                     {bid.loiCancelRemark && <div className="wt-120 mr-5 fs-12">
                                       <span className="caption-color">{`Cancel ${rfq.type === 8 ? 'PO' : 'LOI'} Remark :`}</span><div className="truncate-long-text" title={bid.loiCancelRemark}>{bid.loiCancelRemark}</div>
                                            </div> }
                                     {(bid.isLoiSent && !bid.isLOICancelled && bid.loiAcceptValidTo >= systemTime && bid.cancelLoiEnableorDisable && bid.cancelLoiSendCount < bid.minimumCountSendToCancelLoi) ?<button className="fs-12 curP loi-cancelled-color fSemibold mt-5 mb-8" onClick={(e) => this.cancelledLOI(e, bid)}>Cancel LOI</button>:(bid.isAccept === true &&bid.isLoiSent && !bid.isLOICancelled && bid.cancelLoiEnableorDisable) && <button className="fs-12 curP loi-cancelled-color fSemibold mt-5 mb-8" onClick={(e) => this.cancelledLOI(e, bid)}>Cancel LOI</button>}
                                     {bid.isWithDrawBid && !bid.isAccessBidWithdrawn && rfq.rfqDetails.biddingEnd > systemTime && rfq.rfqDetails.acceptPartialSolution && <button className ="fs-12 curP theme-color fSemibold mt-5 mb-8" onClick={(e) => this.revokeWithdrawBid(e, bid)}>Revoke Bid</button>}
                                    {bid.estimatedTimeOfDepartureDate && <div className="wt-250 truncate-long-text fs-12 mt-5"><span className="label-color" title="Estimated Time of Departure Date">ETD: </span><span className="fBold">{bid.estimatedTimeOfDepartureDate && Moment(bid.estimatedTimeOfDepartureDate).format('DD/MM/YYYY hh:mm a')}</span></div> || null}
                                    {bid.estimatedTimeOfDepartureDate && <div className="wt-250 truncate-long-text fs-12 mt-5"><span className="label-color" title="Estimated Time of Arrival Date">ETA: </span><span className="fBold">{bid.estimatedTimeOfArrivalDate && Moment(bid.estimatedTimeOfArrivalDate).format('DD/MM/YYYY hh:mm a')}</span></div> || null}
                                    {
                                       !!(bid.tripBidEnd && !bid.isLoiSent && !(bid.isAccept === true) && !(bid.isAccept === false)) &&
                                       <div className="fs-14 table-text-color">
                                          <Timer from={trip.biddingDetails.from} to={bid.tripBidEnd} currentTime={systemTime} isRelayBid={true} />
                                       </div>
                                    }
                                    { isVishaka() && 
                                       trip.CPAcceptValidFrom && trip.CPAcceptValidTo &&                
                                       (trip.CPAcceptValidTo >= systemTime || (trip.CPAcceptValidTo < systemTime)) && 
                                       <div className='wt-120'>
                                             <Timer from={trip.CPAcceptValidFrom} to={trip.CPAcceptValidTo} currentTime={systemTime} />
                                       </div>
                                    }
                                 </div>
                              </div>
                              {displayBaseVolume && <div className="" onClick={() => { this.setState({ trip }) }}>
                                 <span className="table-text-color">Business Allocation:
                                                <Input type="number"
                                       // onChange={(e) => {this.onChangeBusinessAll(trip, e, bid.transporterId)}} 
                                       onChange={(e) => this.onBusinessChange(trip, e, bid.transporterId)}
                                       onBlur={(e) => { this.onChangeBusinessAll(trip, bid.business_allocation, bid.transporterId) }}
                                       name="trucksCount"
                                       value={bid.business_allocation}
                                       placeholder=""
                                       className="col-3 inBlock fs-12 ml-5"
                                    />
                                 </span>
                              </div>
                              }
                              {!isCoromandel() && !isVishaka() && rfq.shareOfBusiness && rfq.rfqDetails.biddingEnd < systemTime && <div>
                                       <span className="table-text-color fs-14 mb-5">Share Of Business:
                                       <input
                                          type="number"
                                          className='border-bottom-light-2 wt-50'
                                          onChange={(e) => this.onChangeSOB(e, bid, sortedBidsLTC)}
                                          value={(sobValues || []).find(el => el.trip_id == bid.tripId && el.transporter_id === bid.transporterId) ? ((sobValues || []).find(el => el.trip_id == bid.tripId && el.transporter_id === bid.transporterId) || {}).share_of_business_percentage : bid.share_of_business_percentage}
                                          onBlur={() => this.postSOB(bid)}
                                          onKeyDown={e => (["e", "E", "+", "-", "."].includes(e.key)) && e.preventDefault()}
                                          readOnly={sobInputReadOnly || [10,13,12].includes(dashboardActiveView)}
                                          />
                                    </span>
                                    {isBidSelected && !((sobValues || []).find(el => el.trip_id == bid.tripId && el.transporter_id === bid.transporterId) ? ((sobValues || []).find(el => el.trip_id == bid.tripId && el.transporter_id === bid.transporterId) || {}).share_of_business_percentage : bid.share_of_business_percentage) && <div className='error-color fs-12 tCenter'>Enter the Share of Business</div>}
                              </div>}
                              {/* {isVishaka() && rfq.shareOfBusiness && rfq.rfqDetails.biddingEnd < systemTime && (
                                 <div>
                                    <span className="table-text-color fs-14 mb-5">Share Of Business:
                                       <input
                                          type="number"
                                          className='border-bottom-light-2 wt-50'
                                          onChange={(e) => this.vistaaronChangeSOB(e, bid, sortedBidsLTC)}
                                          value={this.getVistaarDefaultSOBValue(bid, sortedBidsLTC)}
                                          onBlur={() => this.postSOB(bid)}
                                          onKeyDown={e => (["e", "E", "+", "-", "."].includes(e.key)) && e.preventDefault()}
                                          readOnly={sobInputReadOnly || [10, 13, 12].includes(dashboardActiveView)}
                                       />
                                    </span>
                                    {isBidSelected && !this.getVistaarDefaultSOBValue(bid, sortedBidsLTC) && (
                                       <div className='error-color fs-12 tCenter'>Enter the Share of Business</div>
                                    )}
                                 </div>
                              )} */}
                              {(isCoromandel()|| isVishaka()) && rfq.shareOfBusiness && rfq.rfqDetails.biddingEnd < systemTime && <div>
                                 <span className="table-text-color fs-14 mb-5">Share Of Business:
                                    <input
                                       type="number"
                                       className="border-bottom-light-2 wt-50"
                                       onChange={(e) => this.onChangeSOBCoroMandel(e, bid, sortedBidsLTC)}
                                       value={this.getCoromandelDefaultSOBValue(bid, sortedBidsLTC)}
                                       onKeyDown={e => (["e", "E", "+", "-", "."].includes(e.key)) && e.preventDefault()}
                                       readOnly={sobInputReadOnly || [10, 13, 12].includes(dashboardActiveView)}
                                    />
                                 </span>
                                 {isBidSelected && !this.getCoromandelDefaultSOBValue(bid, sortedBidsLTC) && (
                                    <div className="error-color fs-12 tCenter">Enter the Share of Business</div>
                                 )}
                              </div>}
                              {/* {
                                 bid.dph_from_date && bid.dph_to_date && 
                                 <div className="fs-12 mt-5">DPH Validity: <br/><div className='theme-color fs-13'>{bid.dph_from_date && Moment(bid.dph_from_date).format('DD MMM YYYY')} - {bid.dph_to_date && Moment(bid.dph_to_date).format('DD MMM YYYY')}</div></div>
                              }
                              {
                                 bid.dph_percentage &&
                                 <div className="fs-12 mt-5 flex">DPH Percentage: <span className='theme-color fs-14 ml-5'>{bid.dph_percentage}</span>{bid.dph_price_increase ? <UpArrow className="ht-15 wt-20"/> : <DownArrow className="ht-15 wt-20"/>}</div>
                              }
                              {
                                 bid.current_price && 
                                 <div className="fs-12 mt-5 flex">Current Price:<span className='theme-color fs-14 fBold ml-5 mt--3'>₹{bid.current_price}</span></div>
                              } */}
                              {bid.samePriceOrderText && <div className="fs-12"> 
                              Same Bid Price : <span className="fs-12 theme-color fBold">{bid.samePriceOrderText}</span>
                              </div>}

                              {(bid.tripContractTenureFrom && bid.tripContractTenureTo) && <div className="fs-12"> 
                              Contract Tenure : 
                              <div>{bid.tripContractTenureFrom && <span className="fs-12 op-79 lh-15p pb-5 theme-color fBold">  {Moment(bid.tripContractTenureFrom).format('Do MMM, YYYY')} </span> } 
                              {bid.tripContractTenureTo &&<span className="fs-12 op-79 lh-15p pb-5 theme-color"> -  <span className='theme-color fBold'>{Moment(bid.tripContractTenureTo).format('Do MMM, YYYY')} </span></span>}</div>
                              </div>}
                              
                              <div className="ml-5 mb-15">
                                 <SEOIcon className="curP fBold fs-18 wt-20 ht-30" 
                                 onClick={
                                 (e) => { 
                                    e.stopPropagation();
                                    this.setState({ currentIndex: trip.id + id + bidIndex, openPopup: true })}}></SEOIcon>
                                 {
                                    this.state.currentIndex === trip.id + id + bidIndex && this.state.openPopup && <OutsideClickHandler
                                       onOutsideClick={() => {
                                          this.setCurrentIndex(-1);
                                       }}>
                                       <BidHistoryPopUp
                                       biddingDetails={{ price: bid.price, tatValue: (bid.tatObj || {}).value, tatUnit: (bid.tatObj || {}).unit }}
                                       index={trip.id + id + bidIndex}
                                       tripBids={tripBids}
                                       fetchBids={fetchBids}
                                       tripId ={trip.id}
                                       linerId = {bid.liner_id}
                                       transporterId={bid.transporterId}
                                       rfqType = {rfq.type}
                                       />
                                    </OutsideClickHandler>
                                 }
                              </div>
                              
                           </div>}
                        </div>
                     )
                  })
               }
               {
                  (isCoromandel() || isVishaka()) &&
                  rfq.shareOfBusiness && rfq.rfqDetails.biddingEnd < systemTime &&
                  this.props.selectedBids &&
                  this.props.selectedBids.length > 0 &&(
                        <button
                           onClick={this.submitAllSOB}
                           className="pa b-20 ht-25 br-20 white-color bg-theme fs-14 fBold pl-30 pr-30 hCenter"
                        >
                           Submit All SOB
                        </button>
                  )
               }
               
               {rfq.isEnableWithdrawBid && Array.from({length: Math.max(0, maxActiveBidCount - activeBids.length)}).map((_, i) => (
                  <div key={`placeholder-${i}`} className={Classname('flex flex-middle pl-15', {
                     'wt-250': (trip.rfqType !== 5 || ![13,14,15].includes(trip.rfqType)),
                     'wt-300': (trip.rfqType === 5 || [13,14,15].includes(trip.rfqType))
                  })} />
               ))}
               {rfq.isEnableWithdrawBid && <div className="wt-150">{(trip.bids || []).map(bid => {
                     if(bid.isWithDrawBid) {
                           return (
                              <div>
                           <div className="fSemibold header-dark-color mr-10 fs-13">{`${bid.transporterName} (${bid.price})`}</div>
                           {bid.isWithDrawBid && !bid.isAccessBidWithdrawn && <><br />
                           <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-withdraw-bid fSemibold fs-12">Bid Withdrawn</span>
                           </>}
                           {
                           bid.isWithDrawBid &&
                               !bid.isAccessBidWithdrawn &&
                              <button className="fs-12 curP theme-color fSemibold" onClick={(e) => this.revokeWithdrawBid(e, bid)}>Revoke Bid</button>
                           }
                        </div>
                        )
                     }
                  })}
               </div>}
            </div>
         </Fragment>
      );
   }
   handleCounterPrice = (e, type, item) => {
      e.preventDefault()
      e.stopPropagation()
      // debugger;
      if (type === 'accept') {
         this.props.postChallengePrice(item.tripId, {
            price: Number(item.counterPrice),
            counter_status: COUNTER_ACCEPT,
            transporter_id: item.transporterId,
            transporter_name: item.transporterName,
            type: 2,
            tat: {
               unit: item.tatObj.unit,
               value: Number(item.tatObj.value),
               name: item.tatObj.name
            },
         });
      } else {
         this.props.postChallengePrice(item.tripId, {
            price: Number(item.price),
            counter_status: COUNTER_REJECT,
            transporter_id: item.transporterId,
            transporter_name: item.transporterName,
            type: 2,
            tat: {
               unit: item.tatObj.unit,
               value: Number(item.tatObj.value),
               name: item.tatObj.name
            },
         });
      }
   }
   checkForSingleMode = (trips = []) => {
      for (let i = 0; i < trips.length; i++) {
         if (trips[i].rfqType === SINGLE_MODE || trips[i].rfqType === 12 ) {
            return true;
         } else if (trips[i].rfqType === MULTI_MODE || trips[i].rfqType === EXIM_RFQ_TYPE || [13,14,15].includes(trips[i].rfqType)) {
            return false;
         }
         else if (trips[i].rfqType === SECONDARY_MODE) {
            return true;
         }
         else if(trips[i].rfqType === AWL_MULTI_MODE || trips[i].rfqType === CONTAINER_RFQ) {
            return true;
         }
         else if(trips[i].rfqType === GENERAL_PROCUREMENT) {
            return true;
            break;
         }
      }
   }

   renderChargesDetails = (trip) => {
      const hasBids = (trip && trip.bids && trip.bids.length > 0);
      return (
         <Fragment key={`${trip.id}-charges`}>
            <div className="flex flex-middle pl-5 pt-5 pr col-1 fRegular">
               <div className="fs-13 pb-8 wt-100 mr-10"> <b>Name</b> </div>
               <div className="fs-13 pb-8 wt-100 mr-10"> <b>Seeker Default </b> </div>
               {hasBids && (trip.bids || []).map((bid) => {
                  return <div className={"fs-13 mb-8 wt-100 mr-10"}> {bid.transporterName} </div>
               })}
            </div>
            <div className="flex flex-middle pl-5 pb-5 pt-5 pr col-1 fRegular border-top-light">
               <div className="fs-13 pb-8 wt-100 mr-10"> <b>Trip Cost</b> </div>
               <div className="fs-13 pb-8 wt-100 mr-10"> <b>-</b> </div>
               {hasBids && (trip.bids || []).map((bid) => {
                  return <div className={"fs-13 mb-8 wt-100 mr-10"}>{bid.tripCost}</div>
               })}
            </div>
            {
               (trip.multiModeHeadingCharges || []).map((head) => {
                  const defaultType = (trip.multiModeHeadingCharges || []).filter(obj => obj.headingChargesValue === head.headingChargesValue)
                  return (
                     <div className="flex flex-middle pl-5 pb-5 pt-5 pr col-1 fRegular border-top-light">
                        <div className="fs-13 pb-8 wt-100 mr-10"> <b>{head.headingChargesValue}</b> </div>
                        <div className="fs-13 pb-8 wt-100 mr-10"> {defaultType && defaultType.length > 0 ? <b>{defaultType[0].headingChargesBudget}</b> : '-'}</div>
                        {hasBids && (trip.bids || []).map((bid) => {
                           const chargeType = (bid.multiModeHeadingCharges || []).filter(obj => obj.headingChargesValue === head.headingChargesValue)
                           if (chargeType && chargeType.length > 0) {
                              return <div className={"fs-13 mb-8 wt-100 mr-10"}> {chargeType[0].headingChargesBudget || ''} </div>
                           }
                        })}
                     </div>
                  )
               })
            }
            <div className="flex flex-middle pl-5 pb-5 pt-5 pr col-1 fRegular border-top-light">
               <div className="fs-13 pb-8 wt-100 mr-10"> <b>Total</b> </div>
               <div className="fs-13 pb-8 wt-100 mr-10"> <b>{trip.biddingDetails.qbr}</b> </div>
               {hasBids && (trip.bids || []).map((bid) => {
                  return <div className={"fs-13 mb-8 wt-100 mr-10"}>{bid.price}</div>
               })}
            </div>
         </Fragment>
      )
   }

   getCourierOrderText = (trip, isOCharge) => {
      const { rfq , maxTransportersCountRFQ, selectedBids} = this.props;
      const orderHeader = [];
      let bidMaxLength = maxTransportersCountRFQ;

      if(bidMaxLength && bidMaxLength === 0) {
         bidMaxLength = (rfq.trips || []).reduce((sum, trip) => {
            if(trip.bids && trip.bids.length > sum) 
             sum = trip.bids.length;
             return sum;
         },0)
      }
   
      for(let i = 0 ; i < bidMaxLength ; i++) {
         let trpBids = 0;
         let selBid = 0;
         (trip || []).forEach(trp => {
            const orderBid = (trp.bids || []).find(bid => bid.orderText === `L${i + 1}`);
            if(orderBid) {
               if(selectedBids.find(selectd => ((selectd.id === orderBid.id) && (orderBid.orderText === selectd.orderText)))) {
                  selBid += 1;
               }
               trpBids += 1;
            }
         })
         orderHeader.push(
                     <th width="250">
                        <input
                           type="checkbox"
                           checked= {trpBids && (trpBids === selBid)}
                           onClick={(e) => this.toggleAllOrdersText(e, i, `L${i + 1}`, trip)}
                        />
                        {`L${i + 1} ( Quote / TAT / WQ / SA )`}
                     </th>
                  )
      }

      return orderHeader;
   }

   isAllChecked = (trip, tripIdx) => {
      const { selectedBids, rfq, systemTime } = this.props;
      let tripBidlen = 0;
      let selBidlen = 0;
      (trip || []).forEach((tripList, tripIdx) => {
         if(rfq.rfqDetails.biddingEnd < systemTime) {
            tripBidlen += tripList.bids.length;
            selBidlen += (tripList.bids && ((selectedBids || []).filter((selectedBid) => {
               return selectedBid.tripId === tripList.id;
            }).length));
         }
      })
      return (selBidlen && selBidlen === tripBidlen)
   }

   renderCourierTable = () => {
      const { rfq, courierZones, isApprovalMode, systemTime, selectedBids, transporterBidCCharges, fetchTranspBidCommonCharges, tripBids, fetchBids, fromZones, toZones } = this.props;
      const dashboardActiveView = this.props.dashboardActiveView ? this.props.dashboardActiveView : getDashboardActiveView();
      const isApproveOfLoi = (dashboardActiveView === 10);
      const isApproveMessage = (dashboardActiveView === 10) || (dashboardActiveView === 12);
      // const oChargeOrderText = rfq.otherCharges && this.getCourierOrderText(rfq.otherCharges, true) || [];

      return (
         <Fragment>
            {
               (fromZones|| []).map((cSlab, courierIdx) => {
                  return (toZones|| []).map((c2Slab, courier2Idx) => {
                     const trip = (rfq.trips || []).filter(trip => ((trip.zoneName || trip.additionalZoneFrom) === cSlab.name && (trip.zone && trip.zone.zone_to || trip.additionalZoneTo) === c2Slab.name));
                     const orderText = this.getCourierOrderText(trip);
                     if(trip && trip.length > 0) {
                     return (
                        // <ResponsiveTable className="pv-10 ph-10">
                           <div className="courier-table mt-10">
									<table className='col-1' cellpadding="0" cellspacing="0">
                                 {(trip || []).map((tripList, tripIdx) => {
                                 return (
                                       <Fragment>
                                          {tripIdx === 0 && <thead>
                                             <tr>
															{(rfq.rfqDetails.biddingEnd < systemTime) && <th className="first_header"></th>}
															<th colspan={`${6 + orderText.length}`} className="second_seeker" style={{zIndex:'auto'}}>{`${cSlab.name} - ${c2Slab.name}`}</th>
                                                {/* <th colspan={`${2 + orderText.length}`}>{c2Slab.name}</th> */}
                                             </tr>
                                             <tr>
															{(rfq.rfqDetails.biddingEnd < systemTime) && <th style={{ width: '10px' }} className="first">
                                                   <input 
                                                      type="checkbox" 
                                                      checked={this.isAllChecked(trip, tripIdx)}
                                                      onClick={(e) => this.toggleAllZoneBids(e, trip)} 
                                                   />
                                                </th>}
                                                {/* {(rfq.rfqDetails.biddingEnd < systemTime) && <th></th>} */}
															<th className={(rfq.rfqDetails.biddingEnd < systemTime) ? "second_seeker wt-60" : "zone first"}>Zone</th>
															<th width="100" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "third_seeker wt-60" : "second_inprogress_seeker wt-60"}>Movement Type</th>
															<th width="25" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "fourth_seeker wt-60" : "third_inprogress_seeker wt-60"} >Mode Type</th>
															<th width="25" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "fifth_seeker" : "fourth_inprogress_seeker"} >{rfq.rfqDetails && rfq.biddingDetails ? `Slabs (${rfq.biddingDetails.pricingBasisName})` : 'Slabs'}</th>
															<th width="100" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "sixth_seeker" : "fifth_inprogress_seeker"}>QBR</th>
															<th width="50" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "seventh_seeker" : "sixth_inprogress_seeker"}>Max TAT</th>
                                                      {/* <td>LPP(Price)</td> */}
                                                {orderText}
                                             </tr>
                                          </thead>}
                                          <tbody>
                                             <tr>
															{(rfq.rfqDetails.biddingEnd < systemTime) && <td style={{ borderBottom: '1px solid', width: '10px',borderLeft:'1px solid'}} className="first">
                                                <input 
                                                   type="checkbox"
                                                   checked={ tripList.bids.length && ((selectedBids || []).filter((selectedBid) => {
                                                      return selectedBid.tripId === tripList.id;
                                                   }).length) === (tripList.bids || []).length} 
                                                   onClick={this.toggleAllBids.bind(this, tripList)}
                                                /></td>}
															<td style={{ borderBottom: '1px solid' }} className={(rfq.rfqDetails.biddingEnd < systemTime) ? "second_seeker zone" : "first zone"}>{tripList.zoneName || tripList.additionalZoneFrom}</td>
															<td style={{ borderBottom: '1px solid' }} width="30" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "third_seeker" : "second_inprogress_seeker"}>{tripList.movementName}</td>
															<td style={{ borderBottom: '1px solid' }} width="25" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "fourth_seeker" : "third_inprogress_seeker"}>{tripList.modeName}</td>
															<td style={{ borderBottom: '1px solid' }} width="25" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "fifth_seeker" : "fourth_inprogress_seeker"}>{tripList.slabs && `${tripList.slabs.from} - ${tripList.slabs.to}`}</td>
															<td style={{ borderBottom: '1px solid' }} width="100" className={(rfq.rfqDetails.biddingEnd < systemTime) ? "fifth_col sixth_seeker" : "fifth_col fifth_inprogress_seeker"}>
                                                   {tripList.zone.qbr || tripList.additionalMaxQBR}
                                                   {rfq &&
                                                      (rfq.rfqDetails.biddingEnd < systemTime) &&
                                                      <div className="mb-5 mt-5">
                                                         <span className="table-text-color fs-12 fBold">Challenge Price: </span><br />
                                                         <span className="header-medium-color fSemibold">
                                                            ₹ <input
                                                               className="ht-20 fSemiBold border-bottom-light-2 wt-60"
                                                               placeholder="CP"
                                                               value={this.state.cpvalue[tripList.id] || ''}
                                                               onChange={(e) => {
                                                                  const { cpvalue } = this.state;
                                                                  const isValidInput = /^\+?\d*\.?\d*$/.test(e.target.value);
                                                                  if(isValidInput) {
                                                                     cpvalue[tripList.id] = e.target.value
                                                                     this.setState({ cpvalue });
                                                                  }
                                                               }}
                                                               onBlur={(e) => {
                                                                  if (this.state.cpvalue[tripList.id] && this.state.cpvalue[tripList.id].length > 0) {
                                                                     this.toggleAllBids(tripList);
                                                                  }
                                                               }}
                                                            />
                                                            {
                                                               this.state.cpvalue[tripList.id] &&
                                                               <span className="theme-color fs-12 ml-5 mr-5 mt-5 curP"
                                                                  onClick={() => {
                                                                     this.props.submitPrice(this.state.cpvalue[tripList.id], tripList);
                                                                     this.setState({ cpvalue: {} });
                                                                  }}
                                                               >
                                                                  Send
                                                               </span>
                                                            }
                                                         </span>
                                                      </div>
                                                   }
                                                </td>
															<td style={{ borderBottom: '1px solid', borderRight: '1px solid' }} className={(rfq.rfqDetails.biddingEnd < systemTime) ? "seventh_seeker" : "sixth_inprogress_seeker"}>{tripList.zone.max_tat || tripList.additionalMaxTAT}</td>
                                                {(orderText || []).map((order, orderInd) => {
                                                      const bid = tripList.bids[orderInd];
                                                      const id = bid && bid.id || '';
                                                      return(<td style={{ borderBottom: '1px solid', borderRight: '1px solid' }} key={`bid_${orderInd}`}>
                                                               {bid ?
                                                                  <div className="">
                                                                     <div className="seeker-checkBox">
                                                                        <input 
                                                                           type="checkbox" 
                                                                           checked={selectedBids.findIndex((bid) => { return bid.id === id; }) > -1}
                                                                           className="ht-12 ml-5"
                                                                           onClick={() => this.selectBid(bid)}
                                                                        />
                                                                        <span>{bid.transporterName}</span>
                                                                        <span className="fSemibold ml-10">
                                                                           {bid.price} / {bid.maxTat} / 
                                                                           <span className={'orange-color'}> {bid.weightedAverage} </span> / 
                                                                           <span className={'success-color'}> {bid.serviceAvailability && (bid.serviceAvailability + '%') || 'N/A'} </span>
                                                                        </span>
                                                                     </div>
                                                                     <div className="fs-14 fSemibold mb-5 mt-5">
                                                                        {bid.challengePrice &&
                                                                           <div className="fSemibold success-color mr-10 fs-14">₹ {bid.challengePrice}<span className="fs-10 caption-color"> Challenge Price </span></div>
                                                                        }
                                                                        <div className="fs-14 fSemibold mb-2">
                                                                           {bid.isCounter && !bid.cpState && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-12">Counter</span>}
                                                                           {bid.cpState && (bid.cpState === CHALLENGE_PRICE_ACCEPTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-accept fSemibold fs-12">CP Accepted</span>}
                                                                           {bid.cpState && (bid.cpState === CHALLENGE_PRICE_REJECTED) && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-reject fSemibold fs-12">CP Rejected</span>}
                                                                        </div>
                                                                        {bid.isSentLoiApprover && !isApproveOfLoi && <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5">{`${rfq.type === 8 ? 'PO' : 'LOI'} Sent for Approver`}</span>}
                                                                        {bid.isLoiSent && bid.isAccept !== false && bid.isAccept !== true && !isApproveMessage &&
                                                                           <span className={Classname("header-dark-color pr-2 pl-2 pt-2 pb-2 br-5", {
                                                                              "bg-counter": !(bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= systemTime),
                                                                              "bg-error": (bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= systemTime)
                                                                           })}>
                                                                              {
                                                                                 bid.loiAcceptValidTo <= systemTime
                                                                                    ?
                                                                                    <Fragment>{`${rfq.type === 8 ? 'PO' : 'LOI'} Ignored`}</Fragment>

                                                                                    :
                                                                                    <Fragment>{`${rfq.type === 8 ? 'PO' : 'LOI'} Sent`}</Fragment>
                                                                              }
                                                                              {/* {(bid.seekerRemarks && bid.seekerRemarks.length > 0) &&
                                                                                 <Fragment>
                                                                                    <a data-tip='tooltip' data-for={`seeker-remark-tooltip-${id}`}> <span className="tooltip-icon fBold">i</span> </a>
                                                                                    <ReactTooltip globalEventOff='click' id={`seeker-remark-tooltip-${id}`} type="dark" effect="solid">
                                                                                       <span> {bid.seekerRemarks} </span><br />
                                                                                    </ReactTooltip>
                                                                                 </Fragment>
                                                                              }
                                                                              {(bid.seekerInstructions && bid.seekerInstructions.length > 0) &&
                                                                                 <Fragment>
                                                                                    <a data-tip='tooltip' data-for={`seeker-instruction-tooltip-${id}`}> <span className="tooltip-icon fBold">R</span> </a>
                                                                                    <ReactTooltip globalEventOff='click' id={`seeker-instruction-tooltip-${id}`} type="dark" effect="solid">
                                                                                       <span> {bid.seekerInstructions} </span><br />
                                                                                    </ReactTooltip>
                                                                                 </Fragment>
                                                                              } */}
                                                                           </span>
                                                                        }
                                                                           {bid.isLoiSent && bid.isAccept === true && <span className="header-dark-color bg-accept pr-2 pl-2 pt-2 pb-2 br-5">LOI Accepted</span>}
                                                                           {bid.isLoiSent && bid.isAccept === false && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">LOI Rejected</span>}
                                                                           {bid.isLoiSent === false && bid.isAccept === false && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">LOI Rejected</span>}
                                                                           <div>{bid.isLoiApproved && <>
                                                                              <span className="header-dark-color bg-approved pr-2 pl-2 pt-2 pb-2 br-5"> LOI  Approved
                                                                              <a data-tip data-for={`scrollAApprovalContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                                                                                 <ReactTooltip
                                                                                    id={`scrollAApprovalContent-${index}`}
                                                                                    type="light"
                                                                                    effect="solid"
                                                                                    place="right"
                                                                                    className="tooltip-trip-shadow"
                                                                                    delayHide={100}
                                                                                 >
                                                                                    <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                                                                                       <section className="flex mt-25 flex-column">
                                                                                          <ApprovalMatrixDetails 
                                                                                          lineItem={((bid.approval_matrix || [])[0] || {}).levels || []} 
                                                                                          bid={bid}
                                                                                          approvalUser={bid.approval_matrix && ((((((bid.approval_matrix || [])[0] || {}).levels || [])[bid.bid_approved_emails.length] || {}).usernames || []).join(', ') || '') || ''}/>
                                                                                       </section>
                                                                                    </div>
                                                                                 </ReactTooltip> 
                                                                           </span></>}</div>
                                                                           <div>{isApproveOfLoi && <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5">{`Approve ${rfq.type === 8 ? 'PO' : 'LOI'}`}</span>} </div>
                                                                     </div>
                                                                     <div className="pr inBlock mr-10">
																						<CostIcon className="curP fBold fs-18 wt-30 ht-30" 
                                                                                 onClick={(e) => { 
                                                                                 e.stopPropagation();
                                                                                 fetchTranspBidCommonCharges({
                                                                                    movementType: tripList.movementTypeId,
                                                                                    modeType: tripList.modeTypeId,
                                                                                    transporterId: bid.transporterId
                                                                              });
                                                                                 this.setState({ commonCharges: id , isShowCCPopUp: true}) }}>
                                                                        </CostIcon>
                                                                        {
                                                                           this.state.commonCharges === id && this.state.isShowCCPopUp && <OutsideClickHandler
                                                                              onOutsideClick={() => {
                                                                                 this.setState({ commonCharges: '', isShowCCPopUp: false })
                                                                              }}>
                                                                              <CommonChargesPopUp 
                                                                                 transporterBidCCharges={transporterBidCCharges}
                                                                              />
                                                                           </OutsideClickHandler>
                                                                        }
                                                                     </div>
																							<div className="pr inBlock">
                                                                        <SEOIcon className="curP fBold fs-18 wt-20 ht-30" onClick={(e) => { e.stopPropagation();this.setState({ currentIndex: id }); this.setState({ openPopup: true }) }}></SEOIcon>
                                                                        {
                                                                        this.state.currentIndex === id && this.state.openPopup && <OutsideClickHandler
                                                                           onOutsideClick={() => {
                                                                              this.setCurrentIndex(-1);
                                                                           }}>
                                                                           <BidHistoryPopUp
                                                                              index ={id}
                                                                              tripBids={tripBids}
                                                                              fetchBids={fetchBids}
                                                                              tripId ={bid.tripId}
                                                                              transporterId={bid.transporterId}
                                                                              linerId={bid.liner_id}
                                                                              rfqType={rfq.type}
                                                                           />
                                                                        </OutsideClickHandler>}
                                                                     </div>
                                                                  </div> : ""
                                                               }
                                                         </td>)
                                                   }
                                                )}
                                             </tr>
                                          </tbody>
                                       </Fragment>
                                 )})}
                              </table>
                           </div>
                        // </ResponsiveTable>
                     )}
                  })
               })
            }
            {/* {rfq.otherCharges && rfq.otherCharges.length > 0 &&
               <ResponsiveTable className="pv-10 ph-10">
                     <div className="courier-table">
                        <table className='col-1' cellpadding="0" cellspacing="0">
                           <thead>
                              <tr>
                                 <th colspan={`${4}`}>Common Charges</th>
                              </tr>
                              <tr>
                                 <th width="100">Description</th>
                                 <th width="100">Movement Type</th>
                                 <th width="100">Mode Type</th>
                                 <th width="100">QBR</th>
                              </tr>
                           </thead>
                           {rfq.otherCharges && rfq.otherCharges.map((oCharge, oChargeIdx) => {
                              return (<tbody>
                              <tr>
                                 <td style={{ borderBottom: '1px solid' }}>{oCharge.commonChargeName}</td>
                                 <td style={{ borderBottom: '1px solid' }}>{oCharge.movementName}</td>
                                 <td style={{ borderBottom: '1px solid' }}>{oCharge.modeName}</td>
                                 <td style={{ borderBottom: '1px solid', borderRight: '1px solid' }}>{oCharge.commonChargeCost}</td>
                              </tr>
                           </tbody>)})}
                        </table> 
                     </div>
               </ResponsiveTable>
            } */}
         </Fragment>
      )
   }

   showViewLOIRemarksPopup = (tripDetail, hasCharges) => {
      
      this.setState({
         viewLOIremarksdetailsPopup:true,
         bid: null,
         selectedTrip: tripDetail,
      }, scroll)
   }
   showUploadfilePopup = (tripDetail, hasCharges) => {
      
      this.setState({
         showUploadPopup:true,
         selectedTrip: tripDetail,
         bid: null
      }, scroll)
   }
   downloadUploadedFile = (fileName) => {
      const { dispatch } =  this.props;
      dispatch({
         type: DOWNLOAD_UPLOADED_FILE,
         param: {
            fileName
         }
      });
  }
  
// onRemarksChange = (e) => {
//    console.log("entered")
//    this.setState({ loi_remarks: e.target.value });
// }
onUploadLoiDocs = (file) => {
   const  { dispatch } = this.props;
     dispatch({
         type: UPLOAD_DOCUMENT,
         file,
         onSuccess: (data) => { 
            const { loi_docs } = this.state;
            loi_docs.push(data);
            this.setState({
         loi_docs
         });
         }
     })
}
deleteDoc = (index) => {
   const { loi_docs } = this.state;
   loi_docs.splice(index, 1);
   this.setState({
      loi_docs
   });
}
saveUploadFile=(tripId)=>{
      const { dispatch, match ,rfq } = this.props;
      const tegUser = JSON.parse((getCookie('teg-user')));
      const userName = tegUser.adminName;
      const data = {
         tripId,
         // tripId: "601db4e76ea74fb7bab7b0e223d1aae5",
         loi_remarks_doc: [
             {
               //   name: "1698323313130EximCargo (1).xlsx",
               name: this.state.loi_docs.map(doc => doc.name).join(', '), // Convert array to string,
               //   remarks: "Test",
               remarks: this.state.loi_remarks,
               userName: userName,
             }
         ]
     }
      dispatch({
         type: POST_TRIP_FILE_REMARKS,
         data
      }) 
      this.setState({
         showUploadPopup:false
      });
}

   reactivateTk11 = (e, bid) => {
      e.stopPropagation();
      this.props.reactivateTk11(bid);
   }

   onOpenCancelCPPopUp= (e, bids) => {
      e.stopPropagation();
      this.setState({
         isCancelCPPopup: true,
         bids 
      })
	}

   onCancelCPPopUP = () => {
      this.setState({
         isCancelCPPopup: false,
         bids: null
      })
   }

   onCancelCP = () => {
      const { rfq } = this.props;
      const { bids } = this.state;
      const data = {
         rfq_id: rfq.id,
         transporter_id: bids.transporterId,
         trip_id: bids.tripId
      }
      this.props.onCancelCP(data);
      this.onCancelCPPopUP();
   }

   getLOIStatus = (bid, rfqType)  =>  {
      return (
         <div className={'fs-12 fSemibold mt-5 mb-5'}>
            {bid.isLoiSent && bid.isAccept === true && <span className="header-dark-color bg-accept pr-2 pl-2 pt-2 pb-2 br-5">{`${rfqType === 8 ? 'PO' : 'LOI'} ${bid.isLoiAutoAccepted ? 'Auto ' : ''}Accepted`}</span>}
            {bid.isLoiSent && bid.isAccept === false && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">{`${rfqType === 8 ? 'PO' : 'LOI'} Rejected`}</span>}
            {bid.isLoiSent === false && bid.isAccept === false && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">{`${rfqType === 8 ? 'PO' : 'LOI'} Rejected`}</span>}
            {bid.isLOICancelled && <span className="header-dark-color bg-loi-cancelled pr-2 pl-2 pt-2 pb-2 br-5">{`${rfqType === 8 ? 'PO' : 'LOI'} Cancelled`}</span>}
         </div>
      )
   }

   getCoromandelDefaultSOBValue = (bid, bids) => {
      const { sobValues } = this.state;

      const tripId = bid.tripId || bid.trip_id;
      const transporterId = bid.transporterId || bid.transporter_id;

      const existingSOB = (sobValues || []).find(
         el => el.trip_id == tripId && el.transporter_id == transporterId
      );

      if (
         existingSOB &&
         existingSOB.share_of_business_percentage !== undefined &&
         existingSOB.share_of_business_percentage !== null
      ) {
         return existingSOB.share_of_business_percentage;
      }

      
      if (
         bid.share_of_business_percentage !== undefined &&
         bid.share_of_business_percentage !== null &&
         Number(bid.share_of_business_percentage) > 0
      ) {
         return bid.share_of_business_percentage;
      }

      const transportersForTrip = (bids || []).filter(
         b => (b.tripId || b.trip_id) === tripId
      );

      if (transportersForTrip.length === 1) {
         return 100;
      }

      return '';
   };



   autoPopulateSOB = (bids) => {
      const { sobValues } = this.state;

      if (!bids || bids.length === 0) return;

      
      const tripGroups = {};
      bids.forEach(bid => {
         const tripId = bid.tripId || bid.trip_id;
         if (!tripGroups[tripId]) {
            tripGroups[tripId] = [];
         }
         tripGroups[tripId].push(bid);
      });

     
      const singleTransporterSOB = [];

      Object.keys(tripGroups).forEach(tripId => {
         const tripBids = tripGroups[tripId];

         if (tripBids.length === 1) {
            const bid = tripBids[0];

            singleTransporterSOB.push({
               trip_id: tripId,
               transporter_id: bid.transporterId || bid.transporter_id,
               company_id: bid.companyId || bid.company_id,
               share_of_business_percentage: 100,
               orderText: bid.orderText || bid.order_text,
               is_accept: bid.isAccept || bid.is_accept || false
            });
         }
      });

      if (singleTransporterSOB.length > 0) {
         this.setState({
            sobValues: singleTransporterSOB,
            isSOBPriceUpdated: true
         });

         
         const { selectedBids } = this.props;
         if (selectedBids?.length) {
            const updated = selectedBids.map(sb => {
               const sob = singleTransporterSOB.find(
                  s =>
                     s.trip_id === (sb.tripId || sb.trip_id) &&
                     s.transporter_id ===
                     (sb.transporterId || sb.transporter_id)
               );

               return sob
                  ? {
                     ...sb,
                     share_of_business_percentage: 100,
                     sumOfSOB: 100
                  }
                  : sb;
            });

            this.props.setBids(updated);
         }

         return; 
      }

   
      const hasExistingSOB = bids.some(
         bid =>
            bid.share_of_business_percentage !== undefined &&
            bid.share_of_business_percentage !== null
      );

      if (hasExistingSOB && (!sobValues || sobValues.length === 0)) {
         const existingSobValues = bids
            .filter(
               bid =>
                  bid.share_of_business_percentage !== undefined &&
                  bid.share_of_business_percentage !== null
            )
            .map(bid => ({
               trip_id: bid.tripId || bid.trip_id,
               transporter_id: bid.transporterId || bid.transporter_id,
               company_id: bid.companyId || bid.company_id,
               share_of_business_percentage: bid.share_of_business_percentage,
               orderText: bid.orderText || bid.order_text,
               is_accept: bid.isAccept || bid.is_accept || false
            }));

         if (existingSobValues.length) {
            this.setState({
               sobValues: existingSobValues,
               isSOBPriceUpdated: true
            });
            return;
         }
      }

      if (
         sobValues &&
         sobValues.length > 0 &&
         sobValues.every(
            sob =>
               sob.share_of_business_percentage !== undefined &&
               sob.share_of_business_percentage !== null
         )
      ) {
         return;
      }

      const newSobValues = [];

      Object.keys(tripGroups).forEach(tripId => {
         const tripBids = tripGroups[tripId];
         const total = tripBids.length;

         const base = Math.floor(100 / total);
         const remainder = 100 % total;

         tripBids.forEach((bid, index) => {
            newSobValues.push({
               trip_id: tripId,
               transporter_id: bid.transporterId || bid.transporter_id,
               company_id: bid.companyId || bid.company_id,
               share_of_business_percentage:
                  index === 0 ? base + remainder : base,
               orderText: bid.orderText || bid.order_text,
               is_accept: bid.isAccept || bid.is_accept || false
            });
         });
      });

      this.setState({
         sobValues: newSobValues,
         isSOBPriceUpdated: true
      });

      const { selectedBids } = this.props;
      if (selectedBids?.length) {
         const updated = selectedBids.map(sb => {
            const sob = newSobValues.find(
               s =>
                  s.trip_id === (sb.tripId || sb.trip_id) &&
                  s.transporter_id ===
                  (sb.transporterId || sb.transporter_id)
            );

            return sob
               ? {
                  ...sb,
                  share_of_business_percentage:
                     sob.share_of_business_percentage,
                  sumOfSOB: 100
               }
               : sb;
         });

         this.props.setBids(updated);
      }
   };



   onChangeSOBCoroMandel = (e, bid, bids) => {
      const { sobValues } = this.state;
      const { rfq, selectedBids } = this.props;
      const tripId = bid.tripId || bid.trip_id;
      const transporterId = bid.transporterId || bid.transporter_id;

      const presentValue = (sobValues || []).findIndex(
         el => el.trip_id == tripId && el.transporter_id == transporterId
      );

      const orderValue = (sobValues || []).find(
         el => el.orderText === 'L1' && el.trip_id == tripId
      ) || (bids || []).find(el => el.orderText === 'L1');

      let sum = 0;

      if (e.target.value > 100) {
         this.setState({ isSOBPriceUpdated: false });
         return;
      }

      
      (bids || []).forEach(el => {
         const elTransporterId = el.transporterId || el.transporter_id;
         const elTripId = el.tripId || el.trip_id;

         if (elTransporterId !== transporterId) {
            const sobPresent = (sobValues || []).find(
               sob => sob.trip_id === elTripId && sob.transporter_id === elTransporterId
            );
            sum += (sobPresent ? Number(sobPresent['share_of_business_percentage'] || 0) :
               Number(el['share_of_business_percentage'] || 0));
         } else {
            sum += Number(e.target.value || 0);
         }
      });

      (bids || []).map(el => el.sumOfSOB = sum);

      if (e.target.value && sum > 100) {
         this.setState({ isSOBPriceUpdated: false });
         alert('Sum of SOB should not be more than 100%');
         return;
      }

      if (presentValue > -1) {
         sobValues[presentValue]['share_of_business_percentage'] = e.target.value && Number(e.target.value);
      } else {
         sobValues.push({
            "trip_id": tripId,
            "transporter_id": transporterId,
            "company_id": bid.companyId || bid.company_id || getUser().companyId,
            "share_of_business_percentage": e.target.value && Number(e.target.value),
            "orderText": bid.orderText || bid.order_text,
            "is_accept": bid.isAccept || bid.is_accept
         });
      }

      this.setState({ sobValues, isSOBPriceUpdated: true });

      let isTripPresent = false;
      (selectedBids || []).forEach(el => {
         const elTripId = el.tripId || el.trip_id;
         const elTransporterId = el.transporterId || el.transporter_id;

         if (elTripId === tripId) {
            isTripPresent = true;
            el.sumOfSOB = sum;
            if (transporterId === elTransporterId && !el.share_of_business_percentage) {
               el.share_of_business_percentage = e.target.value && Number(e.target.value);
            }
         }
      });

      if (isTripPresent) {
         this.props.setBids(selectedBids);
      }
   };

   generateSOBValues = (bids) => {
      if (!bids || bids.length === 0) return [];

      const tripGroups = {};

      bids.forEach(bid => {
         const tripId = bid.tripId || bid.trip_id;
         if (!tripGroups[tripId]) {
            tripGroups[tripId] = [];
         }
         tripGroups[tripId].push(bid);
      });

      const sobValues = [];

      Object.keys(tripGroups).forEach(tripId => {
         const tripBids = tripGroups[tripId];

         if (tripBids.length === 1) {
            const bid = tripBids[0];
            sobValues.push({
               trip_id: tripId,
               transporter_id: bid.transporterId || bid.transporter_id,
               company_id: bid.companyId || bid.company_id,
               share_of_business_percentage: 100
            });
         }
      });

      return sobValues;
   };


   submitAllSOB = () => {
      let { sobValues } = this.state;
      const { dispatch, match, rfq, selectedBids } = this.props;

      if (!sobValues || sobValues.length === 0) {
         sobValues = this.generateSOBValues(selectedBids);
      }

      if (!sobValues || sobValues.length === 0) {
         alert('No Share of Business values to submit');
         return;
      }

      const tripGroups = {};
      sobValues.forEach(sob => {
         if (!tripGroups[sob.trip_id]) {
            tripGroups[sob.trip_id] = 0;
         }
         tripGroups[sob.trip_id] += Number(sob.share_of_business_percentage || 0);
      });

      
      const invalidTrips = Object.entries(tripGroups).filter(([_, sum]) => sum !== 100);
      if (invalidTrips.length > 0) {
         alert('Share of Business for all trips must sum to 100%');
         return;
      }

      const sob_list = sobValues.map(sob => {
         const { orderText, is_accept, ...sobData } = sob;
         return sobData;
      });

      // UPDATE SELECTED BIDS WITH SOB VALUES BEFORE POSTING
      const updatedSelectedBids = selectedBids.map(bid => {
         const sobEntry = sobValues.find(
            sob =>
               sob.trip_id === (bid.tripId || bid.trip_id) &&
               sob.transporter_id === (bid.transporterId || bid.transporter_id)
         );

         if (sobEntry) {
            const tripSum = tripGroups[sobEntry.trip_id] || 0;
            return {
               ...bid,
               share_of_business_percentage: sobEntry.share_of_business_percentage,
               sumOfSOB: tripSum
            };
         }
         return bid;
      });

      // Update the selectedBids in state/props
      this.props.setBids(updatedSelectedBids);

      // Now post SOB
      this.props.postSOB(sob_list);
   };


   render() {
      const {
         rfq,
         trips,
         vehicleTypes,
         vehicleBodyTypes,
         offset,
         tripsCount,
         loadingTrips,
         paymentCycles,
         pricingBasis,
         isApprovalMode,
         systemTime,
         courierZones,
         courierMovements,
         courierModes,
         slabList,
         fromZones,
         toZones,
         currencyTypes,
         transporters,
         getSeekerTransporters,
         loi_remarks
      } = this.props;
      const { bid, trip, tripDetail, tripLPP, hasCharges } = this.state;
      const { selectedBids, isTK11 } = this.props;
      const legBasedTrips = (trips || []).filter((trip) => {
         return (trip.rfqType === MULTI_MODE) || (trip.rfqType === SECONDARY_MODE) || (trip.rfqType === EXIM_RFQ_TYPE) || [13,14,15].includes(trip.rfqType)
      });
      const costBasedTrips = (trips || []).filter((trip) => {
         return ((trip.rfqType === MULTI_MODE || trip.rfqType === EXIM_RFQ_TYPE || [13,14,15].includes(trip.rfqType)) && trip.multimodalLineType === MULTI_MODE_COST)
      });

      const isSingleMode = this.checkForSingleMode(trips);
      return (
         <React.Fragment>

            {/* <StickyContainer className="responsive-table overflowAuto box-shadow "> */}
               <div className="mr-15 ml-15 ph-60 pv-20 mb-20 br-5 mb-20  box-shadow">
                  <TripTableHeader
                     offset={offset}
                     fetchTrips={this.props.fetchTrips}
                     showAddTrip={this.props.showAddTrip}
                     showPagination={this.props.showPagination}
                     vehicleBodyTypes={vehicleBodyTypes}
                     vehicleTypes={vehicleTypes}
                     viewMode={true}
                     header={'Bids'}
                     searchPlaceholder={'Search Bids'}
                     countText={`${this.getCountText(rfq.type)} Found`}
                     tripsCount={tripsCount}
                     includesOtherCharges={rfq.includesOtherCharges}
                     rfqType={rfq.type}
                     acceptPartialSolution={rfq.rfqDetails.acceptPartialSolution}
                     secondaryContractType={rfq.rfqDetails.secondaryContractType}
							courierTatWeight={rfq.courierTatWeight}
							courierPriceWeight={rfq.courierPriceWeight}
							rfqServiceType={rfq.serviceType}
                     courierZones={courierZones}
                     rfqDetails={rfq.rfqDetails}
                     courierMovements={courierMovements}
                     courierModes={courierModes}
                     slabList={slabList}
                     fromZones={fromZones}
                     toZones={toZones}
                     companyId={rfq.companyId}
                     getVehicleTypes={this.props.getVehicleTypes}
                     transporters={transporters}
                     isShowTransporter={true}
                     getSeekerTransporters={getSeekerTransporters}
                     biddingPercentageSolution={rfq.rfqDetails.biddingPercentageSolution}
                  />
                  <StickyContainer className="responsive-table overflowAuto">
                  <>
                  {rfq.type === 9 ?
                     <DisposalProductSeekerBids
                        trips={trips}
                        rfq={rfq}
                        systemTime={this.props.systemTime}
                        selectedBids={this.props.selectedBids}
                        setBids={this.props.setBids}
                        dashboardActiveView={this.props.dashboardActiveView}
                     />
                        :
                     <div>
                        <div className="inner-container wt-max-content min-wt-100p">
                        {/* <ResponsiveTable> */}
                        {this.state.isBidsShown && rfq.rfqDetails.serviceType !== 3 &&
                           <Fragment>
                           <Sticky topOffset={60} disableCompensation={true}>
                              {({
                                 style, isSticky
                              }) => (
                                    <header>
                                       <div className={Classname("flex flex-middle mb-10", {
                                          'border-bottom-theme pb-10 pt-10 box-shadow ': isSticky
                                       })}
                                          style={{ ...style, marginTop: isSticky ? '60px' : 0, background: 'white', zIndex: 1 }}
                                       >
                                          {!isTK11 && !(rfq.type === 1 && ['737'].includes(rfq.companyId)) && <div className="wt-70"></div>}
                                          <div className="fBold fs-14 header-dark-color wt-150">Line Items</div>
                                          {rfq.type === 6 && <div className="fBold fs-14 header-dark-color wt-120 pl-15">Provider</div>}
                                          <div className="fBold fs-14 header-dark-color wt-100  pl-15 ">L1 Hits | Plain Hits</div>
                                          <div className={Classname("fBold fs-14 header-dark-color pl-15", {
                                            'wt-300': (rfq.type === 5 || [13,14,15].includes(rfq.type)),
                                            'wt-200': (rfq.type !== 5 && ![13,14,15].includes(rfq.type))
                                          })}>Reference</div>
                                          {!isApprovalMode && this.getLineItemsHeader()}
                                          {rfq.isEnableWithdrawBid && <div className="fBold fs-14 header-dark-color wt-150">Bid Withdrawn</div>}
                                       </div>
                                    </header>
                                 )}
                           </Sticky>
                           {
                              isSingleMode && (trips || []).map((trip, index) => {
                                 return (
                                 this.renderRowItems(trip, index)
                                 )
                              })
                           }
                           
                           {
                              !isSingleMode && (legBasedTrips.length > 0) &&
                              <Fragment>
                                 {legBasedTrips.map((trip, index) => {
                                    if ((trip.subTrips || []).length > 0) {
                                       return (trip.subTrips || []).map((subTrip, sIndex) => {
                                          const subTripCurrencyType = (currencyTypes|| []).find(el => el.currency_type === subTrip.legCostValue) || {};
                                          return (<Fragment>
                                             {sIndex === 0 && <div className="flex flex-middle border-top-light pt-10 pb-10 bg-theme-light pr col-1 fRegular">
                                                <div className="wt-50 pl-15">
                                                   <DropdownIcon className="ht-10" />
                                                </div>
                                                <div className="fs-14 table-text-color wt-150">
                                                   <div>
                                                      <span>{trip.from + ' - ' + trip.to}</span>
                                                   </div>
                                                   {rfq && (rfq.rfqDetails || {}).ftlContractType === 2 && <div>
                                                   <span className='fBold'>Slab: </span> <span>{trip.fromRange + ' - ' + trip.toRange}</span>
                                                   </div> || ''}
                                                   {trip.biddingDetails.businessVolumeValue ? <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5">
                                                      {trip.biddingDetails.businessVolumeValue} {trip.biddingDetails.businessVolumeUnitName}
                                                   </div> : null}
                                                   {trip.vehicleTypeName ? <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                                                      {trip.vehicleTypeName}, {trip.vehicleBodyTypeName}
                                                   </div> : null}
                                                   <div> {trip.productCategoryTypeName} </div>
                                                </div>
                                                <div className="fs-14 table-text-color wt-140"></div>
                                                <div className={Classname("fs-14 table-text-color", {
                                                   'wt-300': (rfq.type === 5 || [13,14,15].includes(rfq.type)),
                                                   'wt-200': (rfq.type !== 5 && ![13,14,15].includes(rfq.type)),
                                                })}>
                                                   {trip.totalCeilingPrice && trip.rfqType !== 5 && <span> Ceiling Price : {trip.totalCeilingPrice}</span>}
                                                   {trip.rfqType === 5 &&
                                                      <Fragment>
                                                         <span> Ceiling Price : 
                                                         {trip.totalCeilingPriceINR && <span className="ml-5">₹{rfq.rfqDetails.serviceType === 5  ? trip.totalCeilingPriceVolINR : trip.totalCeilingPriceINR}</span>} 
                                                         {(rfq.rfqDetails.serviceType === 5 || HIKAL.includes(rfq.companyId) || [13,14,15].includes(trip.rfqType)) && trip.priceInBaseCurrency !== 'INR' ?
                                                         trip[`totalCeilingPriceVol${trip.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary' }`] && <span className="ml-10">{trip.priceInBaseCurrencySymbol || ''}{trip[`totalCeilingPriceVol${trip.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary' }`]}</span> :
                                                         trip[`totalCeilingPrice${trip.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary' }`] && <span className="ml-10">{trip.priceInBaseCurrencySymbol || ''}{trip[`totalCeilingPrice${trip.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary' }`]}</span> || ''}
                                                         </span>
                                                      </Fragment>}
                                                </div>
                                                   
                                                {!isHikal() && (trip.tripCostList || []).map((cost, index) => {
                                                   const costValue = cost[`T${(index + 1)}${trip.rfqType === 5 ? '_inr' : ''}`] || 0 ;
                                                   const costValueUSD = cost[`T${(index + 1)}_${trip.priceInBaseCurrency === 'USD' ? 'usd' : 'secondary'}`] || 0;
                                                   return (
                                                      <div className={Classname("flex flex-middle pl-15 curP fs-14", {
                                                         'wt-200 ml-50': trip.rfqType !== 5,
                                                         'wt-300': trip.rfqType === 5
                                                      })} key={`cost-${index}`}>₹{costValue}
                                                      {costValueUSD &&  trip.priceInBaseCurrency !== 'INR' && <span className="ml-5">{trip.priceInBaseCurrencySymbol || ''}{costValueUSD}</span> || ''}
                                                      </div>
                                                   )
                                                })}
                                             </div>}
                                             {this.renderRowItems(subTrip, sIndex, true)}
                                          </Fragment>)
                                       })
                                    } else {
                                       return this.renderRowItems(trip, index)
                                    }
                                 })}
                              </Fragment>
                           }
                           {
                              !isSingleMode && (costBasedTrips.length > 0) &&
                              <Fragment>
                                 <div className="flex flex-middle border-top-light theme-color fSemibold pt-50 pb-25 pr col-1 fs-20">
                                    Cost Based
                                    </div>
                                 {
                                    costBasedTrips.map((trip, index) => {
                                       return this.renderRowItems(trip, index);
                                    })
                                 }
                              </Fragment>
                           }
                           </Fragment>}
                           {
                              rfq.rfqDetails.serviceType === 3 &&
                                 this.renderCourierTable()
                           }
                        {/* </ResponsiveTable>  */}
                        </div>
                     </div>
                  }</>
                  </StickyContainer>
               </div>
                  {tripDetail &&
                  <Fragment>
                     {!hasCharges ?
                        <div className="pl-15 pr-15"><LineItemDetail lineItem={tripDetail} openLineItem={true} hideLineItem={this.hideTripDetail} pricingBasis={pricingBasis} paymentCycles={paymentCycles} currencyTypes={currencyTypes} rfq={rfq}/></div>
                        :
                        <div className="box-shadow mr-15 ml-15 ph-60 pv-20 mt-20 br-5">
                           <div className="">
                              <div className="flex flex-between flex-middle">
                                 <div className="fBold fs-22 header-medium-color mb-30">
                                    <span className="mr-10"> Cost Charges </span>
                                 </div>
                                 <CloseIcon onClick={this.hideTripDetail} />
                              </div>
                              <div>
                                 <ResponsiveTable>
                                    <div className={Classname("flex flex-middle mb-5 border-bottom-theme pb-10 pt-10 pl-5 box-shadow bg-theme-light", {})}>
                                       <div className="fBold fs-14 header-dark-color wt-100 mr-10">Types</div>
                                       <div className="fBold fs-14 header-dark-color wt-100 mr-10">Default</div>
                                       {this.getLineItemsHeader(true)}
                                    </div>
                                    {
                                       !isSingleMode && (legBasedTrips.length > 0) && this.renderChargesDetails(tripDetail)
                                    }
                                    {
                                       !isSingleMode && (costBasedTrips.length > 0) && this.renderChargesDetails(tripDetail)
                                    }
                                 </ResponsiveTable>
                              </div>
                           </div>
                        </div>
                     }
                  </Fragment>
               }
                {!!this.state.showUploadPopup &&
               <UploadFilePopup
               // onChange={this.onRemarksChange}
               value={this.state.loi_remarks}
               onChange={(e) => this.setState({
                  loi_remarks: e.target.value
               })}
               loi_docs={this.state.loi_docs}
                onUploadLoiDocs={this.onUploadLoiDocs}
                deleteDoc={this.deleteDoc}
                onCancel={() => {
                  if(BEAM.includes(getUser().companyId)) {
                     this.setState({
                        loi_remarks: '',
                        loi_docs: [],
                        showUploadPopup:false,
                     })
                  } else {
                     if(this.state.isSendForApprover) {
                        this.sendLOIForApprover();
                     } else {
                        this.showLoiPopup();
                     }
                  }
               }}
                downloadUploadedFile={this.downloadUploadedFile}
                onSave={() => this.saveUploadFile(this.state.selectedTrip.tripId)}
               />
               }
               {!!this.state.viewLOIremarksdetailsPopup &&
               <ViewLOIRemarks
               data={this.state.selectedTrip.loi_remarks_doc || []}
               onCancel={()=>{this.setState({
                  loi_remarks: '',
                  loi_docs: [],
                  viewLOIremarksdetailsPopup:false,
               })}}
               downloadUploadedFile={this.downloadUploadedFile}
               />
               
               }
               {bid && trip && <div className="box-shadow mr-15 ml-15 ph-60 pv-20 mt-20 br-5">
                  <div className="flex flex-between flex-middle">
                     <div className="fBold fs-22 header-medium-color">
                        <span className="mr-10">₹{bid.price} {!rfq.hideTransportersName && <>{`- ${bid.transporterName}`}</>}</span>
                        <Link className="fs-14 theme-color curP" to={"/seeker/bids/transporters/detail/" + bid.rfqId + '/' + bid.transporterId + '/' + rfq.type}>See All Bids</Link>
                     </div>
                     <CloseIcon onClick={this.closeBidAndTRip} />
                  </div>

                  <div className="flex flex-between pv-25">
                     <div className="flex flex-column wt-250">
                        <div className="flex flex-between flex-middle mb-10">
                           <div className="caption-color fSemibold fs-16">Bidding</div>
                        </div>
                        <div className="flex flex-between flex-middle mb-10">
                           <div className="caption-color fSemibold fs-16">Ceiling Price</div>
                           <div className="header-dark-color fSemibold fs-16">₹{trip.biddingDetails.qbr}</div>
                        </div>
                        <div className="flex flex-between flex-middle mb-10">
                           <div className="caption-color fSemibold fs-16">Opening Bid</div>
                           <div className="header-dark-color fSemibold fs-16">₹{bid.firstBidPrice}</div>
                        </div>
                        <div className="flex flex-between flex-middle mb-10">
                           <div className="caption-color fSemibold fs-16">Last Bid</div>
                           <div className="header-dark-color fSemibold fs-16">₹{bid.lastBidPrice}</div>
                        </div>
                        {bid.isCounter && <div className="flex flex-between flex-middle mb-15 pt-5">
                           <div className="caption-color fSemibold fs-16">Challenge Price</div>
                           <div className="header-dark-color fSemibold fs-16">₹{bid.challengePrice}</div>
                        </div>}
                        {bid.isCounter && <div className="flex flex-between flex-middle mb-10 pt-5 border-top-dark-dashed">
                           <div className="caption-color fSemibold fs-16">Counter Price</div>
                           <div className="challenge-color fSemibold fs-16">₹{bid.price}</div>
                        </div>}
                     </div>
                     <div className="flex flex-column wt-400">
                        <div className="caption-color fSemibold fs-16 mb-5">Vehicle</div>
                        <div className="flex flex-bottom mb-40">
                           <span className="header-dark-color fSemibold fs-16 mr-10">{trip.vehicleTypeName}</span>
                           <span className="caption-color fSemibold fs-14">{trip.vehicleBodyTypeName}</span>
                        </div>
                        <div className="caption-color fSemibold fs-16 mb-5">Placement</div>
                        <div className="flex flex-bottom mb-40">
                           <span className="header-dark-color fSemibold fs-16 mr-10">{trip.placementTimeFormatted}</span>
                        </div>
                     </div>
                     <div className="flex flex-column wt-250">
                        <div className="caption-color fSemibold fs-16 mb-5">Activity</div>
                        <div className="header-dark-color fSemibold fs-16 mb-40">{bid.challengePrice ? 'Challenge Price Sent' : 'N/A'}</div>

                        <div className="caption-color fSemibold fs-16 mb-5">Counter Cutoff Time</div>
                        <div className="header-dark-color fSemibold fs-16 mb-40"><Timer from={null} to={null} /></div>
                     </div>
                  </div>

               </div>}
               {
                  this.state.isPopupOpen &&
                  <Tk11Popup
                     text={'Update the below details.'}
                     subPlants={this.props.rfq && this.props.rfq.subPlantsForTk11 ? this.props.rfq.subPlantsForTk11 : []}
                     onSelect={(item, index) => {
                        const { bid, tk11SelctedPlant } = this.state;
                        const selIndex = tk11SelctedPlant.findIndex(resCode => resCode === bid.tkResponse[index]['planningPoint']);
                        if(selIndex > -1) {
                           tk11SelctedPlant[selIndex] = item.transport_planning_point;
                        } 
                        bid.tkResponse[index]['planningPoint'] = item.transport_planning_point;
                        this.setState({ bid, tk11SelctedPlant });
                     }}
                     response={bid.tkResponse}
                     tk11SelctedPlant={this.state.tk11SelctedPlant}
                     SelectPlanningPoint={(data) => {
                        const { tk11SelctedPlant } = this.state;
                        const selIndex = tk11SelctedPlant.findIndex(resCode => resCode === data)
                        if(selIndex > -1) {
                           tk11SelctedPlant.splice(selIndex, 1);
                        } else {
                           tk11SelctedPlant.push(data);
                        }
                        this.setState({ tk11SelctedPlant });
                     }}
                     onRouteCodeChange={(e, index) => {
                        const { bid } = this.state;
                        bid.tkResponse[index][e.target.name] = e.target.value;
                        this.setState({ bid });
                     }}
                     onTransporterCodeChange={(e, index) => {
                        const { bid } = this.state;
                        bid.tkResponse[index][e.target.name] = e.target.value;
                        this.setState({ bid });
                     }}
                     onConfirm={() => {
                        const { bid, subPlant, tk11SelctedPlant } = this.state;
                        const tkResponseData = (bid.tkResponse || []).filter(res => 
                           tk11SelctedPlant.indexOf(res.planningPoint) > -1 && res.resCode === 'E'
                        )
                        const data = {
                           tk_response: tkResponseData,
                           // routeCode: bid.routeCode,
                           // transporterCode: bid.transporterCode,
                           // planningPoint: subPlant,
                           // finalAmount: bid.price,
                           rfq_id: bid.rfqId,
                           trip_id: bid.tripId,
                           transporter_id: bid.transporterId,
                           transporter_name: bid.transporterName,
                        }
                        // console.table(data)
                        this.props.updateTk11Details(data);
                        this.setState({ isPopupOpen: false, tk11SelctedPlant: [] })
                     }}
                     onCancel={() => { this.setState({ isPopupOpen: false, tk11SelctedPlant: [] }) }}

                  />
               }
               {this.state.isCancelCPPopup &&
                  <ConfirmationPopup
                     text={'Are You Sure You Want To Cancel CP?'}
                     onConfirm={this.onCancelCP}
                     onCancel={this.onCancelCPPopUP}
                  />
               }
         </React.Fragment>
      )
   }
}

export default connect(null, null)(SeekerBidsTable);
